/* istanbul ignore file */
import React, { useEffect, useMemo, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/messages';
import { Container } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/styled-components';
import {
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import {
  disableOnValidationButton,
  disableSharedResponsibility,
  filterAccountingCivjs,
  filterExpertises,
  formatExpertisesWithExpertReport,
  getDeceasedVictims,
  getInjuredVictims,
  getJudgementOnMeritsVictims,
  getVehiculeIds,
  getVictimIds,
  getVictimKeys,
  hasOtherReason,
  priorityClaimReason,
  resolveSlectedDeceasedVictims,
  shouldValidateDesceasedVictims,
  validateCivilJudgementsOnRecap,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import {
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  COMPTABLE_EXPERTISE_ID,
  JUDGEMENT_EXPERTISE_TYPES,
  MEDICAL_EXPERTISE_ID,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  getBeneficiaries,
  useBeneficiaries,
  useDahirAmountByVictimKey,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/hooks';
import CivilJudgementRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap';
import CorrectionalJudgementManagerRecap from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/CorrectionalJudgementManagerRecap';
import { toast } from 'react-toastify';
import {
  get,
  isEmpty,
  cloneDeep,
  isNil,
  uniq,
  without,
  difference,
} from 'lodash';
import deleteIcon from 'images/delete-icon.svg';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import {
  CONTESTATION,
  CONTESTATION_AGAINST,
  EMPTY_JUDGEMENT_ON_MERITS_DOC,
  PROCEDURE_STATUSES,
  PROCEDURE_STEPS,
  VEHICULE_EXPERTISE_FIELDS,
  VICTIM_EXPERTISE_FIELDS,
} from 'containers/data-structure';

import { Config, Listings } from 'containers/AppContainer/typings';
import {
  checkVictimExistanceCivilParty,
  isContested,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import JudgementOnMeritsInfo from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/JudgementOnMeritsInfo';
import AdditionalInfoJudgementOnMerit from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/AdditionalInfoJudgementOnMerit';
import { ISuedPartyType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Dialog } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';
import {
  JudgementADDDocumentType,
  JudgementOnMeritsVictim,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import DeceasedVictim from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/deceasedVictim';
import JudgementOnMeritsForm from 'containers/CourtManagerLegalProceedings/AppealOnMerits/JudgementOnMeritsForm';
import AdditionalInfoJudgementOnMeritForm from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/AdditionalInfoJudgementOnMeritsForm';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import {
  addNewJudgementNonCompensation,
  addNewCivjJudgement,
  checkVictimExistanceCivilPartyById,
  formatAccExpertises,
  formatMechanicalExpertises,
  formatMedExpertises,
  getCivilJudgement,
  getCivilJudgementByVictimId,
  getDeceasedVictim,
  getDeceasedVictimAge,
  isJomAssociatedVictimsIncluded,
  resolveCalculationStartDate,
  resolveDeceasedVictimFees,
  filterJudgementAddDocumentsByDate,
  addAccountingExpertiseAfterMerge,
  updateVehicleAccountingExpertiseAfterMerge,
  isBeneficiaryNotEmpty,
  reasonWithoutCompensationConditions,
  getJudgementAddDocumentsWithoutCivjs,
  getAllBeneficiaries,
  resolveValueFromForm,
  getRateItt,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  getVictimAge,
  getVictimKey,
  getVictimRevenu,
  mergeEvaluationsV2,
  resolveExpertiseValue,
} from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { MODE } from 'containers/CourtManagerLegalProceedings/ExpertReport/constants';
import moment from 'moment';
import {
  CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
  INCIDENT_TYPE,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import SahamDrawer from 'components/SahamDrawer';
import {
  FormContainer,
  StyledSecondaryButton,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';
import { getVictimFullName } from 'containers/LawyerLegalProceedingsPage/judgementAppeal/CivilJudgement/Expertises/utils';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import {
  getAppealAddDocument,
  getResponsibilityShareByType,
  getSubstantiveWithoutCompensation,
  isCivilJudgementVictimSubstantive,
  isExpertReportWithoutDecision,
  isNextOfKinsSubstantive,
  isNextOfKinsWithFormRejection,
} from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import {
  isUserActive,
  showValidator,
} from 'containers/common/LegalProceedings/utils';
import RejectionDialog from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/RejectionDialog';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import {
  getJudgementAddDocuments,
  resolveJudgementAddAppeal,
} from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/utils';
import {
  getCivjVictims,
  getDeceasedJomVictims,
  getJomVictims,
  isDeceasedVictimsOnly,
} from 'containers/LawyerLegalProceedingsPage/utils';
import { filterVictim } from 'containers/CourtManagerLegalProceedings/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { isMonitoringCourtManager, resolveSagisClaim } from 'helpers/utils';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import UpdateStepRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/UpdateStepRecap';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/ValidationDialog';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { CIVIL_JUDGEMENT_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/constants';
import { useSelector } from 'react-redux';
import CivilJudgementForm from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementForm';
import InjuredVictimsRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/InjuredVictimsRecap';
import { VictimType } from 'typings/globalTypes';
import { getTheLatestEvaluationObject } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import { GLOBAL_STATUS } from 'services/constants';
import { formatNextOfKins } from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';

export interface JudgementOnMeritsManagerRecapProps {
  intl: IntlShape;
  listings: Listings;
  uploadDocument: Function;
  setDocumentId: Function;
  documentId: string;
  expertiseReport?: any;
  victims?: any;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestGetJudgementOnMerits: Function;
  requestValidateJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  lawyer: string;
  claimId: number;
  claimNumber: string;
  judgementAddDocuments: JudgementADDDocumentType[];
  dahirAmount: [];
  judgementAdd: any;
  policyInfo: { sagis: {} };
  judgementAddClone: any;
  claim: any;
  judiciaryProcessId: number;
  requestGetJudgementAdd: Function;
  requestGetExpertiseReport: Function;
  requestCreateJudgementOnMeritsContestation: any;
  vehicules: any;
  judgementOnMeritsAppeal: any;
  requestGetJudgementOnMeritsAppeal: any;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: any;
  judgementAddAppeal: any;
  requestGetJudgementAddAppeal: Function;
  civilProceeding: any;
  isManager: boolean;
  requestAddJudgementOnMeritsSupportDocument: Function;
  isCivilProceeding: boolean;
  isMultiple?: boolean;
  jomDeceasedVictims?: any;
  isFirst?: boolean;
  currentJudiciaryProcess?: any;
  isAssignedLawyer: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  requestGetDahirAmount: Function;
  setIsButtonRedirect?: Function;
  setOpenFeeNoteDialog: Function;
  isConsultation: boolean;
  requestMakeDecisionSupportDocument?: Function;
  imagineDocuments: any;
  requestArchiveJudgement?: Function;
  requestGetDocByDocumentumId: Function;
}

export const JudgementOnMeritsManagerRecapAppeal: React.FC<JudgementOnMeritsManagerRecapProps> = ({
  listings,
  uploadDocument,
  uploadedDocument,
  resetUploadedDocument,
  documentId,
  setDocumentId,
  requestGetJudgementOnMerits,
  requestValidateJudgementOnMerits,
  lawyer,
  judgementOnMerits,
  claimId,
  claimNumber,
  policyInfo,
  claim,
  expertiseReport,
  victims,
  vehicules,
  civilProceeding,
  isCivilProceeding,
  isMultiple,
  jomDeceasedVictims,
  isFirst,
  ...props
}): JSX.Element => {
  const isExpertReportNotValidated =
    isExpertReportWithoutDecision(expertiseReport) &&
    get(judgementOnMerits, 'judgementOnMerits.status') === 'PENDING';
  const currentJudiciaryProcess = civilProceeding.find(
    (el: any) => el.id === props.judiciaryProcessId,
  );
  const [civilJudgements, setCivilJudgements] = useState([
    ...getCivilJudgement(judgementOnMerits),
  ]);
  const [sharedResponsability, setSharedResponsability] = useState(
    get(
      judgementOnMerits,
      '[judgementOnMerits][jom][civjs][0][responsibilityShare]',
      null,
    ) ||
      get(
        judgementOnMerits,
        'judgementOnMerits.jom.civjvm.[0].responsibilityShare',
        null,
      ) ||
      get(
        judgementOnMerits,
        'beneficiaries.[0].beneficiary.victim.responsibilityShare',
        null,
      ),
  );

  const [responsibilityRate, setResponsibilityRate] = useState(
    get(
      judgementOnMerits,
      '[judgementOnMerits][jom][civjs][0][responsibilityShare]',
      null,
    ),
  );

  const [openDialog, setOpenDialog] = useState(false);

  const handleChangeSharedResponsability = (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    if (parseInt(e.target.value) >= 0) {
      setSharedResponsability(e.target.value.replace(',', '.'));
      setCivilJudgementOnMeritsForm(
        getCivilJudgement(judgementOnMerits).map((item: any) => ({
          id: item.id,
          isModified: true,
          responsibilityShare: e.target.value.replace(',', '.'),
        })),
      );
    }
  };
  const [deceasedVictim, handleChangeDesceasedVictim] = useState<VictimType[]>(
    [],
  );
  const [formContestationValues, setFormContestationValues] = useState<any>({
    [CONTESTATION.TYPE]: null,
  });
  const [judgementOnMeritsInfo, setJudgementOnMeritsInfo] = useState({});
  const [judgement, setJudgement] = useState({} as any);
  const [judgementOnMeritsInfoForm, setJudgementOnMeritsInfoForm] = useState(
    {},
  );
  const [archiveReason, setArchiveReason] = useState<string>('');

  const [isContestationDrawerOpen, setIsContestationDrawerOpen] = useState(
    false,
  );
  const [openDialogValidation, setOpenDialogValidation] = useState(false);

  const [selectedVictims, setSelectedVictims] = useState<any>([]);
  const civilJudgementVictims = get(
    judgementOnMerits,
    'judgementOnMerits.jom.civjvm',
    [],
  ).filter((item: any) => !item?.expertiseJudgementAddDocumentId);
  const [civjvmRequest, setCivjvmRequest] = useState(
    get(judgementOnMerits, 'judgementOnMerits.jom.civjvm', []),
  );
  const [judgementOnMeritsRequest, setJudgementOnMeritsRequest] = useState({});
  useEffect(() => {
    setJudgementOnMeritsRequest({
      jmv: get(judgementOnMerits, 'judgementOnMerits.jom.jmv', []),
      civjVehicle: get(
        judgementOnMerits,
        'judgementOnMerits.jom.civjVehicle',
        [],
      ),
      civjs: [],
    });
  }, [judgementOnMerits]);

  const getVictims = () => {
    return isCivilProceeding
      ? get(
          civilProceeding.find(
            (cp: any) => cp.id === props.judiciaryProcessId,
          ) || {},
          'victims',
          [],
        )
      : get(props.judgementAddAppeal, 'civilDocuments', [])
          .map((document: any) => get(document, 'victims', []))
          .flat();
  };
  const [dahirAmountByVictimKey] = useDahirAmountByVictimKey(
    victims
      .filter(
        (item: any) =>
          item.injuryPostKey === INJURY_POST_DECEASED &&
          !isEmpty(item?.victimKey),
      )
      .map((item: any) => item.victimKey),
    props.judgementAddDocuments,
    props.dahirAmount,
    props.judgementAddAppeal,
  );
  const [beneficiaries, setBeneficiaries] = useBeneficiaries(
    judgementOnMerits,
    props.judgementAddClone,
    [...jomDeceasedVictims],
    dahirAmountByVictimKey,
    getDeceasedVictims(
      props.judgementAdd,
      props.judgementAddAppeal,
      currentJudiciaryProcess,
    ),
  );
  const [selectedVehicles, setSelectedVehicles] = useState<any>([]);
  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const allJudgementAddDocuments = resolveJudgementAddAppeal(
    getJudgementAddDocuments(
      props.judgementAddDocuments,
      get(props.judgementAddAppeal, 'judgementAddDocuments', []),
      judgementOnMerits,
    ),
    false,
    null,
  );
  const filteredJaddDocuments = getJudgementAddDocumentsWithoutCivjs(
    allJudgementAddDocuments,
    judgementOnMerits,
  );

  const IsVictimChecked = (victimId: number, selectedVictims: any): boolean => {
    const found = selectedVictims.find((el: any) => el === victimId);
    if (found) return true;
    return false;
  };
  const [
    IsDifficultyExecutionChecked,
    setIsDifficultyExecutionChecked,
  ] = useState<boolean>(false);

  const [
    additionalJudgementOnMeritsInfoForm,
    setAdditionalJudgementOnMeritsInfoForm,
  ] = useState({});

  const newCivjvm = Object.values(
    get(judgementOnMeritsRequest, 'civjvm', []),
  ).filter((item: any) => !isEmpty(item));
  const [civilJudgementOnMeritsForm, setCivilJudgementOnMeritsForm] = useState<
    any
  >([]);

  const [isRejectionDialogOpen, setIsRejectionDialogOpen] = useState<boolean>(
    false,
  );
  const [isCJDisabled, setIsCJDisabled] = useState({});

  const handleDifficultyExecutionCheckBox = () => {
    setIsDifficultyExecutionChecked(!IsDifficultyExecutionChecked);
  };

  const handleVictimChangeCheckBox = (victimId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVictim = victims.find((el: any) => el.id === victimId);

    if (event.target.checked) {
      setSelectedVictims([...selectedVictims, selectedVictim.id]);
    } else {
      selectedVictims.splice(
        selectedVictims.findIndex((el: number) => el === victimId),
        1,
      );
      setSelectedVictims([...selectedVictims]);
    }
  };

  const IsVehicleChecked = (
    vehicleId: number,
    selectedVehicles: any,
  ): boolean => {
    const found = selectedVehicles.find((el: any) => el === vehicleId);
    if (found) return true;
    return false;
  };
  const [judgementAddClone, setjudgementAddClone] = React.useState<
    IJudgementAdd | { status: string }
  >({} as IJudgementAdd | { status: string });
  const [
    civilJudgementOnMeritsFormMedicalExpertise,
    setCivilJudgementOnMeritsFormMedicalExpertise,
  ] = useState<any>([]);

  const [
    civilJudgementOnMeritsFormAccountingExpertise,
    setCivilJudgementOnMeritsFormAccountingExpertise,
  ] = useState<any>([]);

  const [
    civilJudgementOnMeritsFormMechanicalExpertise,
    setCivilJudgementOnMeritsFormMechanicalExpertise,
  ] = useState<any>([]);

  const handleVehicleChangeCheckBox = (vehicleId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVehicle = vehicules.find((el: any) => el.id === vehicleId);

    if (event.target.checked) {
      setSelectedVehicles([...selectedVehicles, selectedVehicle.id]);
    } else {
      selectedVehicles.splice(
        selectedVehicles.findIndex((el: number) => el === vehicleId),
        1,
      );
      setSelectedVehicles([...selectedVehicles]);
    }
  };

  const handleFormChange = (fieldName: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) =>
    setFormContestationValues(
      Object.assign(
        {},
        { ...formContestationValues },
        { [fieldName]: event.target.value },
      ),
    );

  const resolveLawyerCompensationAmount = (el: any, desceasedVictims: any) => {
    let deceasedVictim = null;
    let victim = null;
    const civjAppeal = getCivilJudgementByVictimId(
      [...civilJudgements, ...get(judgementOnMeritsRequest, 'civjs', [])],
      el,
    );
    if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2') {
      const jmv =
        get(judgementOnMeritsRequest, 'jmv', []).find(
          (item: JudgementOnMeritsVictim) => item.victimId === el.victimId,
        ) || {};
      deceasedVictim =
        desceasedVictims.find((item: any) => item.victimId === el.victimId) ||
        {};
      return isNextOfKinsSubstantive(
        get(deceasedVictim, 'beneficiaries', []),
        get(listings, 'civilJudgementVictimReason', []),
      )
        ? 0
        : !isNil(get(jmv, 'compensationAmount', null))
        ? Number(get(jmv, 'compensationAmount', null))
        : get(deceasedVictim, 'judiciaryAmount');
    }
    if (el.expertiseId === 1 && !el.isFirstInstance) {
      const victim = civjAppeal.find(cj => !isEmpty(cj.civjmede));
      const civId = get(victim, 'civjmede[0].civilJudgementId', '');
      const civMedId = get(victim, 'civjmede[0].id', '');
      const jomMedExpertise = civilJudgementOnMeritsFormMedicalExpertise.find(
        (el: any) => el.id === civId,
      );
      const expertise = !isEmpty(get(jomMedExpertise, 'medExpertises', []))
        ? get(jomMedExpertise, 'medExpertises', []).find(
            (el: any) => el.id === civMedId,
          )
        : get(victim, 'civjmede[0]', {});
      return get(expertise, 'compensationAmount', '');
    } else if (el.expertiseId === 1 && el.isFirstInstance) {
      const victim = civjAppeal.find(cj => !isEmpty(cj.civjmede));
      const civId = get(victim, 'civjmede[0].civilJudgementId', '');
      const civMedId = get(victim, 'civjmede[0].id', '');
      const jomMedExpertise = civilJudgementOnMeritsFormMedicalExpertise.find(
        (el: any) => el.id === civId,
      );
      const expertise = !isEmpty(get(jomMedExpertise, 'medExpertises', []))
        ? get(jomMedExpertise, 'medExpertises', []).find(
            (el: any) => el.id === civMedId,
          )
        : get(victim, 'civjmede[0]', {});
      return get(expertise, 'compensationAmount', '');
    }
    !el.isFirstInstance
      ? (victim = civjAppeal.find(cj => !isEmpty(cj.civjacce)))
      : (victim = civjAppeal.find(cj => !isEmpty(cj.civjacce)));

    return get(victim, 'civjacce[0].calculatedRevenue', '');
  };

  const resolveRevenu = (el: any) => {
    const civjAppeal = getCivilJudgementByVictimId(
      [...civilJudgements, ...get(judgementOnMeritsRequest, 'civjs', [])],
      el,
    );

    if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2')
      return el.expertiseId === 2
        ? el[VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME]
        : el[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE];

    const victim = civjAppeal.find(cj => !isEmpty(cj.civjacce));
    const civId = get(victim, 'civjacce[0].civilJudgementId', '');
    const civAccId = get(victim, 'civjacce[0].id', '');
    const jomAccExpertise = civilJudgementOnMeritsFormAccountingExpertise.find(
      (el: any) => el.id === civId,
    );
    const expertise = !isEmpty(get(jomAccExpertise, 'accExpertises', []))
      ? get(jomAccExpertise, 'accExpertises', []).find(
          (el: any) => el.id === civAccId && !get(el, 'isDeleted', false),
        )
      : get(victim, 'civjacce', []).find(
          item => !get(item, 'isDeleted', false),
        );

    return get(expertise, 'evaluationAmount', el?.fixedAnnualIncome);
  };

  const allVictimExpertises = useMemo(() => {
    const victimIds = get(expertiseReport, 'victimExpertises', []).map(
      (el: any) => {
        return {
          victimId: el.victimId,
          expertiseId: el.expertiseId,
        };
      },
    );
    const expertiseFirstInstance = get(
      props.expertiseRaportAppeal,
      'victimExpertises',
      [],
    )
      .filter((exp: any) => !exp.isOld && !exp.isRejectedJudgement)
      .filter((item: any) => {
        return !victimIds.some(
          (el: any) =>
            el.victimId === item.victimId &&
            el.expertiseId === item.expertiseId &&
            !el.isOld &&
            !el.isRejectedJudgement,
        );
      })
      .map((el: any) => {
        return {
          ...el,
          isFirstInstance: true,
        };
      });

    const expertReportDefault = get(expertiseReport, 'victimExpertises', [])
      .filter(
        (expertiseRep: any) =>
          !expertiseRep.isOld && !expertiseRep.isRejectedJudgement,
      )
      .map((e: any) => ({
        ...e,
        isFirstInstance: false,
      }));
    return !isEmpty(expertiseFirstInstance)
      ? [...expertReportDefault, ...expertiseFirstInstance]
      : expertReportDefault;
  }, [expertiseReport, props.expertiseRaportAppeal]);

  const deceasedVictimInJom = useMemo(
    () =>
      resolveSlectedDeceasedVictims(
        getDeceasedVictims(
          props.judgementAdd,
          props.judgementAddAppeal,
          currentJudiciaryProcess,
        ),
        [...jomDeceasedVictims],
        get(judgementOnMerits, 'judgementOnMerits.jom.id', ''),
        isMultiple,
      ),
    [],
  );

  const allVehiculeExpertises = useMemo(() => {
    const vehicleIds = get(expertiseReport, 'vehiculeExpertises', []).map(
      (el: any) => {
        return {
          vehiculeId: el.vehiculeId,
          expertiseId: el.expertiseId,
        };
      },
    );
    const expertiseFirstInstance = get(
      props.expertiseRaportAppeal,
      'vehiculeExpertises',
      [],
    )
      .filter((exp: any) => !exp.isOld && !exp.isRejectedJudgement)
      .filter((item: any) => {
        return !vehicleIds.some(
          (el: any) =>
            el.vehiculeId === item.vehiculeId &&
            el.expertiseId === item.expertiseId &&
            !el.isOld &&
            !el.isRejectedJudgement,
        );
      });

    const expertReportDefault = get(
      expertiseReport,
      'vehiculeExpertises',
      [],
    ).filter(
      (expertiseRep: any) =>
        !expertiseRep.isOld && !expertiseRep.isRejectedJudgement,
    );
    return !isEmpty(expertiseFirstInstance)
      ? [...expertReportDefault, ...expertiseFirstInstance]
      : expertReportDefault;
  }, [expertiseReport, props.expertiseRaportAppeal]);

  const victimsEvaluationsToInclude = [
    ...getJomVictims([get(judgementOnMerits, 'judgementOnMerits', {})]),
    ...getDeceasedJomVictims([judgementOnMerits], judgementAddClone),
    ...get(judgementOnMerits, 'judgementOnMerits.jom.civjvm', []).map(
      (el: any) => el.victimId,
    ),
    ...newCivjvm.map((el: any) => el.victimId),
    ...getCivjVictims(get(judgementOnMeritsRequest, 'civjs', [])),
  ];

  const formatEvaluations = (
    victimIds: any,
    judgementOnMerits: any,
    judgementOnMeritsRequest: any,
  ) => {
    return victimIds.map((id: number) => {
      let judiciaryAmount = null;
      let revenu = null;
      let itt = null;

      const victim = victims.find(
        (item: any) => Number(item.id) === Number(id),
      );
      [
        ...get(judgementOnMerits, 'judgementOnMerits.jom.civjs', []),
        ...get(judgementOnMeritsRequest, 'civjs', []),
      ].forEach((el: any) => {
        const civjId = get(el, 'id');
        let found = get(el, 'civjmede', []).find(
          (el: any) => el.victimId === id,
        );
        if (found) {
          const jomMedExpertise = civilJudgementOnMeritsFormMedicalExpertise.find(
            (el: any) => el.id === civjId,
          );
          judiciaryAmount = !isEmpty(jomMedExpertise)
            ? get(
                get(jomMedExpertise, 'medExpertises', []).find(
                  (el: any) => el.id === get(found, 'id'),
                ),
                'compensationAmount',
              )
            : get(found, 'compensationAmount');
          itt = get(found, 'victim.itt');
        } else {
          found = get(el, 'civjacce', []).find((el: any) => el.victimId === id);
          if (found) {
            const jomAccExpertise = civilJudgementOnMeritsFormAccountingExpertise.find(
              (el: any) => el.id === civjId,
            );
            judiciaryAmount = !isEmpty(jomAccExpertise)
              ? get(
                  get(jomAccExpertise, 'accExpertises', []).find(
                    (el: any) => el.id === get(found, 'id'),
                  ),
                  'calculatedRevenue',
                  '',
                )
              : get(found, 'calculatedRevenue');

            itt = get(found, 'victim.itt', victim?.itt);
          }
        }
      });
      [
        ...get(judgementOnMerits, 'judgementOnMerits.jom.civjs', []),
        ...get(judgementOnMeritsRequest, 'civjs', []),
      ].forEach((el: any) => {
        const civjId = get(el, 'id');
        let found = get(el, 'civjacce', []).find(
          (el: any) => el.victimId === id,
        );
        if (found) {
          const jomAccExpertise = civilJudgementOnMeritsFormAccountingExpertise.find(
            (el: any) => el.id === civjId,
          );
          revenu = !isEmpty(jomAccExpertise)
            ? get(
                get(jomAccExpertise, 'accExpertises', []).find(
                  (el: any) => el.id === get(found, 'id'),
                ),
                'evaluationAmount',
              )
            : get(found, 'evaluationAmount');
        }
      });
      return {
        victimId: id,
        judiciaryAmount,
        responsibilityShare: sharedResponsability,
        revenu,
        itt,
      };
    });
  };

  const handleCivJvmChange = (id: any, fieldName: string, victim?: any) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    let victimToUpdate: any = civjvmRequest.find((el: any) => el.id === id);
    const civilJudgementVictims = [...civjvmRequest];
    const index = civilJudgementVictims.findIndex(
      (item: any) => item.id === id,
    );
    if (isEmpty(victimToUpdate) && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVictims,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        victim,
        INCIDENT_TYPE.VICTIM,
      );
    }
    if (index !== -1) {
      civilJudgementVictims[index] = {
        ...victimToUpdate,
        [fieldName]: event.target.value,
        responsibilityShare: sharedResponsability,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(victimToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }

    setCivjvmRequest(civilJudgementVictims);
  };

  const handleCivjVehicleChange = (
    id: any,
    fieldName: string,
    vehicle?: any,
  ) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    let vehicleToUpdate: any =
      get(judgementOnMeritsRequest, 'civjVehicle', []).find(
        (el: any) => el?.id === id,
      ) || {};

    const civilJudgementVehicles = [
      ...get(judgementOnMeritsRequest, 'civjVehicle', []),
    ];
    const index = civilJudgementVehicles.findIndex(
      (item: any) => item.id === id,
    );

    if (isEmpty(vehicleToUpdate) && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVehicles,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        vehicle,
        INCIDENT_TYPE.VEHICLE,
      );
    }
    if (index !== -1) {
      civilJudgementVehicles[index] = {
        ...vehicleToUpdate,
        [fieldName]: event.target.value,
        responsibilityShare: sharedResponsability,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(vehicleToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }
    setJudgementOnMeritsRequest({
      ...judgementOnMeritsRequest,
      civjVehicle: civilJudgementVehicles,
    });
  };

  const [contestationReasons, setContestationReasons] = useState<
    Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: Set<number>;
    }>
  >(new Set());

  const [isValidated, setIsValidated] = useState<boolean>(false);
  const [
    beneficiaryContestationReasons,
    setBeneficiaryContestationReasons,
  ] = useState<
    Set<{
      reasons: [];
      instruction: string;
      judgementOnMeritsBeneficiaryId: number | null;
    }>
  >(new Set());
  const setContestationReasonsRequest = (
    contestationReasons: Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: Set<number>;
    }>,
    correctionalContestationReasons: {
      reasons: Set<number>;
      instruction: string;
    },
    beneficiaryContestationReasons: Set<{
      reasons: [];
      instruction: string;
      judgementOnMeritsBeneficiaryId: number | null;
    }>,
  ) => {
    if (
      isEmpty(contestationReasons) &&
      isEmpty(correctionalContestationReasons.reasons) &&
      isEmpty(beneficiaryContestationReasons)
    ) {
      return {};
    }

    return {
      correctionalJudgement: [
        ...setUpCorrectionalJudgements(correctionalContestationReasons),
      ],
      civilJudgement: [...setUpCivilJudgements(contestationReasons)],
      beneficiary: [...setUpBeneficiary(beneficiaryContestationReasons)],
    };
  };

  const setUpBeneficiary = (
    beneficiaryContestationReasons: Set<{
      reasons: any;
      instruction: string;
      judgementOnMeritsBeneficiaryId: number | null;
    }>,
  ) => {
    const beneficiaryContestation = [];
    for (let item of beneficiaryContestationReasons) {
      for (let reason of item.reasons) {
        beneficiaryContestation.push({
          ...item,
          judgementOnMeritsBeneficiaryContestationReasonId: reason,
        });
      }
    }
    beneficiaryContestation.forEach(el => delete el.reasons);
    return beneficiaryContestation;
  };

  const setUpCivilJudgements = (
    contestationReasons: Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: any;
    }>,
  ) => {
    const civilJudgements = [];
    for (let item of contestationReasons) {
      for (let reason of item.contestationReasons) {
        civilJudgements.push({
          ...item,
          judgementOnMeritsContestationReasonId: reason,
        });
      }
    }
    civilJudgements.forEach(el => delete el.contestationReasons);
    return civilJudgements;
  };

  const setUpCorrectionalJudgements = (correctionalContestationReasons: {
    reasons: Set<number>;
    instruction: string;
  }) => {
    const correctionalJudgements = [];
    for (let item of correctionalContestationReasons.reasons) {
      correctionalJudgements.push({
        correctionalJudgementId: get(
          judgementOnMerits['judgementOnMerits']['jom'],
          'cj.id',
        ),
        judgementOnMeritsContestationReasonId: item,
        instruction: correctionalContestationReasons.instruction,
      });
    }
    return correctionalJudgements;
  };

  const [
    correctionalContestationReasons,
    setCorrectionalContestationReasons,
  ] = useState<{
    reasons: Set<number>;
    instruction: string;
  }>({ reasons: new Set(), instruction: '' });

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap']),
  );

  const getLastEvaluation = (el: any) =>
    getTheLatestEvaluationObject(
      getVictimKey(
        el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
        victims || (([] as unknown) as VictimType[]),
      ),
      props.dahirAmount,
    );

  const handleValidateJudgementOnMerits = (
    isValidated: boolean,
    toUpdate: boolean,
  ) => () => {
    props.setIsButtonRedirect && props.setIsButtonRedirect(true);
    const reasonWithoutCompensationEvaluations = getSubstantiveWithoutCompensation(
      get(listings, 'civilJudgementVictimReason', []),
      civjvmRequest,
    ).map((item: any) => {
      const lastMedicalExpertise =
        get(expertiseReport, 'victimExpertises', []).find(
          (el: any) =>
            String(el?.victimId) === String(item?.victimId) &&
            !el.isOld &&
            el.status !== GLOBAL_STATUS.PENDING &&
            el.status !== GLOBAL_STATUS.REJECTED &&
            !el.isRejectedJudgement &&
            String(el.expertiseId) === MEDICAL_EXPERTISE_ID,
        ) || {};
      const lastEvaluation = getLastEvaluation(item);
      return (
        checkVictimExistanceCivilPartyById(
          item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          getVictims(),
        ).includes(true) && {
          gestionMode: '',
          materialAmount: '',
          currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
          judiciaryAmount: 0,
          responsibilityRate: sharedResponsability,
          age: getVictimAge(
            item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            victims,
            claim['lossDate'],
          ),
          mode: MODE.BLESSE,
          rateITT: featureService.hasFeature(
            FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
          )
            ? resolveExpertiseValue(
                item,
                item[VICTIM_EXPERTISE_FIELDS.ITT],
                lastMedicalExpertise,
                lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.ITT],
                get(lastEvaluation, 'rateITT'),
              )
            : item[VICTIM_EXPERTISE_FIELDS.ITT],
          victimKey: getVictimKey(
            item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
            victims,
          ),
          revenu: getVictimRevenu(
            item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            victims,
            props.judiciaryProcessId,
          ),
          lossDate: moment(claim['lossDate']).toISOString(true),
          // rateMedicalPharmaceuticalFees: '',
          transactionPhase: 1,
          isJusticeFeesChecked:
            get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
              ? true
              : false,
          isIDDChecked:
            get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
          iddEffectiveDate: get(judgementOnMeritsInfo, 'calculationStartDate'),
          JudiciartDecisionDate: !isEmpty(
            get(judgementOnMeritsInfoForm, 'judgementDate', ''),
          )
            ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
            : get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate', ''),
        }
      );
    });

    const sagisEvaluationWithoutExpertise = formatEvaluations(
      difference(
        [
          ...uniq([
            ...uniq(getVictimIds(props.judgementAddDocuments)).filter(
              (id: any) =>
                ![
                  ...victims
                    .filter(
                      (v: any) => v.injuryPostKey === INJURY_POST_DECEASED,
                    )
                    .map((v: any) => v.id),
                ].includes(id),
            ),
            ...uniq(
              getVictimIds(
                get(props.judgementAddAppeal, 'judgementAddDocuments', []),
              ),
            ).filter(
              (id: any) =>
                ![
                  ...victims
                    .filter(
                      (v: any) => v.injuryPostKey === INJURY_POST_DECEASED,
                    )
                    .map((v: any) => v.id),
                ].includes(id),
            ),
          ]),
        ],
        get(expertiseReport, 'victimExpertises', []).map(
          (el: any) => el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
        ),
      ),
      judgementOnMerits,
      judgementOnMeritsRequest,
    )
      .filter((item: any) => {
        return reasonWithoutCompensationConditions(
          item,
          judgement,
          [...civjvmRequest, ...newCivjvm],
          ([] as unknown) as VictimType,
          get(listings, 'civilJudgementVictimReason', []),
        );
      })
      .map((el: any) => {
        const lastEvaluation = getLastEvaluation(el);
        return (
          checkVictimExistanceCivilPartyById(
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            getVictims(),
          ).includes(true) && {
            gestionMode: '',
            materialAmount: '',
            currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
            judiciaryAmount: isCivilJudgementVictimSubstantive(
              get(listings, 'civilJudgementVictimReason', []),
              el,
              [...civjvmRequest, ...newCivjvm],
            )
              ? 0
              : el['judiciaryAmount'],
            responsibilityRate: el['responsibilityShare'],
            revenu: !isNil(
              getVictimRevenu(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                props.judiciaryProcessId,
              ),
            )
              ? getVictimRevenu(
                  el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  victims,
                  props.judiciaryProcessId,
                )
              : el['revenu'],
            age: getVictimAge(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              victims,
              claim['lossDate'],
            ),
            mode: MODE.BLESSE,
            lossDate: moment(claim['lossDate']).toISOString(true),
            rateITT: featureService.hasFeature(
              FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
            )
              ? get(el, [VICTIM_EXPERTISE_FIELDS.ITT], null)
                ? get(el, [VICTIM_EXPERTISE_FIELDS.ITT])
                : String(get(lastEvaluation, 'rateITT'))
              : get(el, [VICTIM_EXPERTISE_FIELDS.ITT]),
            victimKey: getVictimKey(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
              victims,
            ),
            // rateMedicalPharmaceuticalFees: '',
            transactionPhase: 1,
            isJusticeFeesChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'responsibility', ''),
                get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.responsibility',
                  '',
                ),
              ) === 'Oui'
                ? true
                : false,
            isIDDChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
              ) === 'Oui'
                ? true
                : false,
            iddEffectiveDate: resolveCalculationStartDate(
              get(additionalJudgementOnMeritsInfoForm, 'calculationStartDate'),
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.calculationStartDate',
                '',
              ),
            ),
            JudiciartDecisionDate: !isEmpty(
              get(judgementOnMeritsInfoForm, 'judgementDate', ''),
            )
              ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
              : get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.judgementDate',
                  '',
                ),
          }
        );
      });
    const sagisEvaluations = allVictimExpertises
      .filter((el: any) => {
        const victim: VictimType | {} =
          deceasedVictim.find((item: any) => item?.victimId === el?.victimId) ||
          {};
        return (
          isJomAssociatedVictimsIncluded(
            isMultiple || isFirst,
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            victimsEvaluationsToInclude,
          ) &&
          reasonWithoutCompensationConditions(
            el,
            judgement,
            [...civjvmRequest, ...newCivjvm],
            (victim as unknown) as VictimType,
            get(listings, 'civilJudgementVictimReason', []),
          )
        );
      })
      .map((el: any) => {
        const lastMedicalExpertise =
          get(expertiseReport, 'victimExpertises', []).find(
            (item: any) =>
              String(item?.victimId) === String(el?.victimId) &&
              !item.isOld &&
              item.status !== GLOBAL_STATUS.PENDING &&
              item.status !== GLOBAL_STATUS.REJECTED &&
              !item.isRejectedJudgement &&
              String(item.expertiseId) === MEDICAL_EXPERTISE_ID,
          ) || {};
        const lastEvaluation = getLastEvaluation(el);
        const objectToReturn = featureService.hasFeature(
          FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
        )
          ? {
              gestionMode: '',
              materialAmount: '',
              currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
              judiciaryAmount: isCivilJudgementVictimSubstantive(
                get(listings, 'civilJudgementVictimReason', []),
                el,
                [...civjvmRequest, ...newCivjvm],
              )
                ? 0
                : resolveLawyerCompensationAmount(el, deceasedVictim),
              responsibilityRate: getResponsibilityShareByType(
                civilJudgements,
                allVictimExpertises,
                deceasedVictim,
                el,
                civilJudgementOnMeritsForm,
                responsibilityRate,
              ),
              funeralFeesAmount:
                el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                  ? get(
                      resolveDeceasedVictimFees(
                        el,
                        get(judgementOnMeritsRequest, 'jmv', []),
                      ),
                      'funeralFees',
                      null,
                    )
                  : undefined,
              medicalFeesAmount:
                el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                  ? get(
                      resolveDeceasedVictimFees(
                        el,
                        get(judgementOnMeritsRequest, 'jmv', []),
                      ),
                      'medicalFees',
                      null,
                    )
                  : undefined,
              rateRecovery: resolveExpertiseValue(
                el,
                el[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
                lastMedicalExpertise,
                lastMedicalExpertise[
                  VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL
                ],
                get(lastEvaluation, 'rateRecovery'),
              ),
              lossDate: moment(claim['lossDate']).toISOString(true),
              revenu: !isNil(
                getVictimRevenu(
                  el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  victims,
                  props.judiciaryProcessId,
                ),
              )
                ? getVictimRevenu(
                    el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                    victims,
                    props.judiciaryProcessId,
                  )
                : el.expertiseId === 1
                ? el[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]
                : resolveRevenu(el),
              age: getVictimAge(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                claim['lossDate'],
              ),
              mode:
                el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                  ? MODE.DECEASED
                  : MODE.BLESSE,
              ratePretium: resolveExpertiseValue(
                el,
                el[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
                lastMedicalExpertise,
                lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
                get(lastEvaluation, 'ratePretium'),
              ),
              rateAestheticDamageWithoutConsequence: resolveExpertiseValue(
                el,
                el[
                  VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE
                ],
                lastMedicalExpertise,
                lastMedicalExpertise[
                  VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE
                ],
                get(lastEvaluation, 'rateAestheticDamageWithoutConsequence'),
              ),
              rateAestheticDamageWithConsequence: resolveExpertiseValue(
                el,
                el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE],
                lastMedicalExpertise,
                lastMedicalExpertise[
                  VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE
                ],
                get(lastEvaluation, 'rateAestheticDamageWithConsequence'),
              ),
              rateCareerPrejudice: resolveExpertiseValue(
                el,
                el[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
                lastMedicalExpertise,
                lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
                get(lastEvaluation, 'rateCareerPrejudice'),
              ),
              rateSchoolingPrejudice: resolveExpertiseValue(
                el,
                el[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
                lastMedicalExpertise,
                lastMedicalExpertise[
                  VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE
                ],
                get(lastEvaluation, 'rateSchoolingPrejudice'),
              ),
              rateIPP: resolveExpertiseValue(
                el,
                el[VICTIM_EXPERTISE_FIELDS.IPP],
                lastMedicalExpertise,
                lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.IPP],
                get(lastEvaluation, 'rateIPP'),
              ),
              rateITT: getRateItt(el, lastMedicalExpertise, lastEvaluation),
              victimKey: getVictimKey(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
                victims,
              ),
              medicalPharmaceuticalFees:
                el[VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES],
              // rateMedicalPharmaceuticalFees: '',
              transactionPhase: 1,
              isJusticeFeesChecked:
                resolveValueFromForm(
                  get(
                    additionalJudgementOnMeritsInfoForm,
                    'responsibility',
                    '',
                  ),
                  get(
                    judgementOnMerits,
                    'judgementOnMerits.jom.responsibility',
                    '',
                  ),
                ) === 'Oui'
                  ? true
                  : false,
              isIDDChecked:
                resolveValueFromForm(
                  get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                  get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
                ) === 'Oui'
                  ? true
                  : false,
              iddEffectiveDate: resolveCalculationStartDate(
                get(
                  additionalJudgementOnMeritsInfoForm,
                  'calculationStartDate',
                ),
                get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.calculationStartDate',
                  '',
                ),
              ),
              JudiciartDecisionDate: !isEmpty(
                get(judgementOnMeritsInfoForm, 'judgementDate', ''),
              )
                ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
                : get(
                    judgementOnMerits,
                    'judgementOnMerits.jom.judgementDate',
                    '',
                  ),
              expType: Number(el.expertiseId),
              isRecentExpertiseVictim: el.isRecentExpertiseVictim,
            }
          : {
              gestionMode: '',
              materialAmount: '',
              currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
              judiciaryAmount: isCivilJudgementVictimSubstantive(
                get(listings, 'civilJudgementVictimReason', []),
                el,
                [...civjvmRequest, ...newCivjvm],
              )
                ? 0
                : resolveLawyerCompensationAmount(el, deceasedVictim),
              responsibilityRate: getResponsibilityShareByType(
                civilJudgements,
                allVictimExpertises,
                deceasedVictim,
                el,
                civilJudgementOnMeritsForm,
                responsibilityRate,
              ),
              funeralFeesAmount:
                el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                  ? get(
                      resolveDeceasedVictimFees(
                        el,
                        get(judgementOnMeritsRequest, 'jmv', []),
                      ),
                      'funeralFees',
                      null,
                    )
                  : undefined,
              medicalFeesAmount:
                el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                  ? get(
                      resolveDeceasedVictimFees(
                        el,
                        get(judgementOnMeritsRequest, 'jmv', []),
                      ),
                      'medicalFees',
                      null,
                    )
                  : undefined,
              rateRecovery: el[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
              revenu: !isNil(
                getVictimRevenu(
                  el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  victims,
                  props.judiciaryProcessId,
                ),
              )
                ? getVictimRevenu(
                    el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                    victims,
                    props.judiciaryProcessId,
                  )
                : el.expertiseId === 1
                ? el[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]
                : resolveRevenu(el),
              age: getVictimAge(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                claim['lossDate'],
              ),
              lossDate: moment(claim['lossDate']).toISOString(true),
              mode:
                el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                  ? MODE.DECEASED
                  : MODE.BLESSE,
              ratePretium: el[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
              rateAestheticDamageWithoutConsequence:
                el[
                  VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE
                ],
              rateAestheticDamageWithConsequence:
                el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE],
              rateCareerPrejudice: el[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
              rateSchoolingPrejudice:
                el[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
              rateIPP: el[VICTIM_EXPERTISE_FIELDS.IPP],
              rateITT: el[VICTIM_EXPERTISE_FIELDS.ITT]
                ? el[VICTIM_EXPERTISE_FIELDS.ITT]
                : el.previousItt,
              victimKey: getVictimKey(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
                victims,
              ),
              medicalPharmaceuticalFees:
                el[VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES],
              rateMedicalPharmaceuticalFees: '',
              transactionPhase: 1,
              isJusticeFeesChecked:
                resolveValueFromForm(
                  get(
                    additionalJudgementOnMeritsInfoForm,
                    'responsibility',
                    '',
                  ),
                  get(
                    judgementOnMerits,
                    'judgementOnMerits.jom.responsibility',
                    '',
                  ),
                ) === 'Oui'
                  ? true
                  : false,
              isIDDChecked:
                resolveValueFromForm(
                  get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                  get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
                ) === 'Oui'
                  ? true
                  : false,
              iddEffectiveDate: resolveCalculationStartDate(
                get(
                  additionalJudgementOnMeritsInfoForm,
                  'calculationStartDate',
                ),
                get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.calculationStartDate',
                  '',
                ),
              ),
              JudiciartDecisionDate: !isEmpty(
                get(judgementOnMeritsInfoForm, 'judgementDate', ''),
              )
                ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
                : get(
                    judgementOnMerits,
                    'judgementOnMerits.jom.judgementDate',
                    '',
                  ),
              expType: Number(el.expertiseId),
              isRecentExpertiseVictim: el.isRecentExpertiseVictim,
            };
        return (
          checkVictimExistanceCivilPartyById(
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as any,
            getVictims(),
          ) &&
          checkVictimExistanceCivilPartyById(
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as any,
            getVictims(),
          )?.includes(true) &&
          objectToReturn
        );
      });
    const nextOfKins = formatNextOfKins(beneficiaries, sharedResponsability);

    const sagisEvalVictimKeys =
      sagisEvaluations && sagisEvaluations.map((el: any) => el?.victimKey);
    const civilDocumentsEvaluations =
      checkVictimExistanceCivilParty(deceasedVictim as any, getVictims()) &&
      checkVictimExistanceCivilParty(
        deceasedVictim as any,
        getVictims(),
      ).includes(true)
        ? deceasedVictim
            .filter(
              (v: any) =>
                !sagisEvalVictimKeys.includes(v.victimKey) &&
                isJomAssociatedVictimsIncluded(
                  isMultiple || isFirst,
                  get(v, 'victimId'),
                  victimsEvaluationsToInclude,
                ) &&
                !isNextOfKinsWithFormRejection(
                  get(v, 'beneficiaries', []),
                  get(listings, 'civilJudgementVictimReason', []),
                ),
            )
            .map((victim: VictimType) => {
              const jmv =
                get(judgementOnMeritsRequest, 'jmv', []).find(
                  (item: JudgementOnMeritsVictim) =>
                    item.victimId === victim?.victimId,
                ) || {};
              return (
                checkVictimExistanceCivilPartyById(
                  victim['victimId'],
                  getVictims(),
                ) &&
                checkVictimExistanceCivilPartyById(
                  victim['victimId'],
                  getVictims(),
                )?.includes(true) && {
                  gestionMode: '',
                  materialAmount: '',
                  currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
                  judiciaryAmount: isNextOfKinsSubstantive(
                    get(victim, 'beneficiaries', []),
                    get(listings, 'civilJudgementVictimReason', []),
                  )
                    ? 0
                    : !isNil(get(jmv, 'compensationAmount', null))
                    ? Number(get(jmv, 'compensationAmount', null))
                    : get(victim, 'judiciaryAmount', ''),
                  responsibilityRate: victim['responsibilityShare'],
                  rateRecovery: null,
                  revenu: !isNil(
                    getVictimRevenu(
                      victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                      victims,
                      props.judiciaryProcessId,
                    ),
                  )
                    ? getVictimRevenu(
                        victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                        victims,
                        props.judiciaryProcessId,
                      )
                    : victim['annualOfIncome'],
                  age: getDeceasedVictimAge(
                    (victim['victimId'] as unknown) as string,
                    deceasedVictim,
                    claim['lossDate'],
                  ),
                  mode: MODE.DECEASED,
                  lossDate: moment(claim['lossDate']).toISOString(true),
                  funeralFeesAmount: get(jmv, 'funeralFees', null),
                  medicalFeesAmount: get(jmv, 'medicalFees', null),
                  ratePretium: null,
                  rateAestheticDamageWithoutConsequence: null,
                  rateAestheticDamageWithConsequence: null,
                  rateCareerPrejudice: null,
                  rateSchoolingPrejudice: null,
                  rateIPP: null,
                  rateITT: null,
                  victimKey: victim['victimKey'],
                  medicalPharmaceuticalFees: null,
                  rateMedicalPharmaceuticalFees: '',
                  transactionPhase: 1,
                  isJusticeFeesChecked:
                    resolveValueFromForm(
                      get(
                        additionalJudgementOnMeritsInfoForm,
                        'responsibility',
                        '',
                      ),
                      get(
                        judgementOnMerits,
                        'judgementOnMerits.jom.responsibility',
                        '',
                      ),
                    ) === 'Oui'
                      ? true
                      : false,
                  isIDDChecked:
                    resolveValueFromForm(
                      get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                      get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
                    ) === 'Oui'
                      ? true
                      : false,
                  iddEffectiveDate: resolveCalculationStartDate(
                    get(
                      additionalJudgementOnMeritsInfoForm,
                      'calculationStartDate',
                    ),
                    get(
                      judgementOnMerits,
                      'judgementOnMerits.jom.calculationStartDate',
                      '',
                    ),
                  ),
                  JudiciartDecisionDate: !isEmpty(
                    get(judgementOnMeritsInfoForm, 'judgementDate', ''),
                  )
                    ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
                    : get(
                        judgementOnMerits,
                        'judgementOnMerits.jom.judgementDate',
                        '',
                      ),
                }
              );
            })
        : [];

    const civilDocumentsVictimKeys =
      civilDocumentsEvaluations &&
      civilDocumentsEvaluations.map((el: any) => el.victimKey);

    const judiciaryProcessEvaluations = get(
      currentJudiciaryProcess,
      'victims',
      [],
    )
      .filter((v: any) => {
        const victimBeneficiaries = beneficiaries.filter(
          (beneficiary: any) => beneficiary?.victimId === v?.id,
        );
        return (
          v[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2' &&
          !sagisEvalVictimKeys.includes(v.victimKey) &&
          !civilDocumentsVictimKeys.includes(v.victimKey) &&
          isJomAssociatedVictimsIncluded(
            isMultiple || isFirst,
            get(v, 'id'),
            victimsEvaluationsToInclude,
          ) &&
          !isNextOfKinsWithFormRejection(
            victimBeneficiaries,
            get(listings, 'civilJudgementVictimReason', []),
          )
        );
      })
      .map((victim: VictimType) => {
        const currentVictim = deceasedVictim.find(
          (el: VictimType) => el.victimId === victim.id,
        );
        const jmv =
          get(judgementOnMeritsRequest, 'jmv', []).find(
            (item: JudgementOnMeritsVictim) =>
              item.victimId === get(victim, 'victimId', victim?.id),
          ) || {};
        return (
          checkVictimExistanceCivilPartyById(
            victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            getVictims(),
          ) &&
          checkVictimExistanceCivilPartyById(
            victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            getVictims(),
          ).includes(true) && {
            gestionMode: '',
            materialAmount: '',
            currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
            judiciaryAmount: isNextOfKinsSubstantive(
              get(currentVictim, 'beneficiaries', []),
              get(listings, 'civilJudgementVictimReason', []),
            )
              ? 0
              : !isNil(get(jmv, 'compensationAmount', null))
              ? Number(get(jmv, 'compensationAmount', null))
              : get(victim, 'judiciaryAmount', ''),
            responsibilityRate: victim['responsibilityShare'],
            rateRecovery: null,
            revenu: !isNil(
              getVictimRevenu(victim['id'], victims, props.judiciaryProcessId),
            )
              ? getVictimRevenu(victim['id'], victims, props.judiciaryProcessId)
              : victim['annualOfIncome'],
            age: getVictimAge(victim['id'], victims, claim['lossDate']),
            mode: MODE.DECEASED,
            lossDate: moment(claim['lossDate']).toISOString(true),
            funeralFeesAmount: get(jmv, 'funeralFees', null),
            medicalFeesAmount: get(jmv, 'medicalFees', null),
            ratePretium: null,
            rateAestheticDamageWithoutConsequence: null,
            rateAestheticDamageWithConsequence: null,
            rateCareerPrejudice: null,
            rateSchoolingPrejudice: null,
            rateIPP: null,
            rateITT: null,
            victimKey: victim['victimKey'],
            medicalPharmaceuticalFees: null,
            rateMedicalPharmaceuticalFees: '',
            transactionPhase: 1,
            isJusticeFeesChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'responsibility', ''),
                get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.responsibility',
                  '',
                ),
              ) === 'Oui'
                ? true
                : false,
            isIDDChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
              ) === 'Oui'
                ? true
                : false,
            iddEffectiveDate: resolveCalculationStartDate(
              get(additionalJudgementOnMeritsInfoForm, 'calculationStartDate'),
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.calculationStartDate',
                '',
              ),
            ),
            JudiciartDecisionDate: !isEmpty(
              get(judgementOnMeritsInfoForm, 'judgementDate', ''),
            )
              ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
              : get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.judgementDate',
                  '',
                ),
          }
        );
      });
    const contestationType = get(
      listings,
      'judgementOnMeritsContestationTypes',
      [],
    ).find(el => el.id === formContestationValues[CONTESTATION.TYPE])?.title;
    const sagisEvals = [
      ...mergeEvaluationsV2(
        [
          ...sagisEvaluations,
          ...civilDocumentsEvaluations,
          ...judiciaryProcessEvaluations,
        ],
        sharedResponsability,
      ),
    ];
    const validationRequest = {
      contestation: {},
      isContested: isContestationDrawerOpen,
      status: toUpdate
        ? jomStatus
        : isEmpty(contestationReasons) &&
          isEmpty(correctionalContestationReasons.reasons)
        ? PROCEDURE_STATUSES.VALIDATED_WITHOUT_CONTESTATION
        : PROCEDURE_STATUSES.APPLICATION_ANNULMENT,
      rejectionReason: get(
        judgementOnMerits,
        'judgementOnMerits.rejectionReason',
      ),
      claimId: Number(claimId),
      claimNumber,
      claimExtCode: claimNumber,
      contestationReasons: setContestationReasonsRequest(
        contestationReasons,
        correctionalContestationReasons,
        beneficiaryContestationReasons,
      ),
      isMultiple,
      jomDate: moment(
        get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
      ).format('DD/MM/YYYY'),
      judgementId: get(judgementOnMerits['judgementOnMerits'], 'id'),
      info: {
        id: judgementOnMerits['judgementOnMerits']['jom']['id'],
        ...judgementOnMeritsInfoForm,
        ...additionalJudgementOnMeritsInfoForm,
      },
      jomId: get(judgementOnMerits, 'judgementOnMerits.jom.id', ''),
      document: {
        ...judgementOnMeritsFormDocument,
        judgementOnMeritsId:
          judgementOnMerits['judgementOnMerits']['jom']['id'],
        id:
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id') &&
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id'),
      },
      beneficiaries,
      correctionalInfo: [
        ...correctionalJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      civilInfo: [
        ...civilJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      newCivjs: get(judgementOnMeritsRequest, 'civjs', []).map((el: any) => ({
        ...el,
        responsibilityShare: parseFloat(sharedResponsability as any),
      })),
      newCivjvm: Object.values(get(judgementOnMeritsRequest, 'civjvm', []))
        .filter((item: any) => !isEmpty(item))
        .map((el: any) => ({
          ...el,
          responsibilityShare: parseFloat(sharedResponsability as any),
        })),
      medExpertises: formatMedExpertises(
        civilJudgementOnMeritsFormMedicalExpertise,
      ),
      accExpertises: formatAccExpertises(
        civilJudgementOnMeritsFormAccountingExpertise,
      ),
      mechanicalExpertises: formatMechanicalExpertises(
        civilJudgementOnMeritsFormMechanicalExpertise,
      ),
      civjVehicleInfo: Object.values(
        get(judgementOnMeritsRequest, 'civjVehicle', []),
      ).filter((item: any) => !isEmpty(item)),
      civjvmInfo: civjvmRequest,
      jmv: getJudgementOnMeritsVictims(
        civilJudgements,
        judgementOnMerits,
        isEmpty(props.judgementAddClone)
          ? judgementAddClone
          : props.judgementAddClone,
        props.judgementAddAppeal,
        currentJudiciaryProcess,
        dahirAmountByVictimKey,
        sharedResponsability,
        get(judgementOnMeritsRequest, 'jmv', []),
        [],
        jomDeceasedVictims,
        isMultiple,
      ),
      procedureType: PROCEDURE_TYPES.APPEAL,
      feeNote: {
        step: PROCEDURE_STEPS.ARRET_ON_MERITS,
        codeIntervenant: get(claim, 'assignment.assignedLawyer'),
      },
      fflipFeeNote: featureService.hasFeature(FEATURES.FEE_NOTE),
      username: currentUserStorage.get().username,
      judiciaryProcessId: get(
        judgementOnMerits['judgementOnMerits'],
        'judiciaryProcessId',
      ),
      sagisEvaluations:
        toUpdate &&
        (jomStatus === STATUS_PENDING || jomStatus === STATUS_REJECTED)
          ? []
          : [
              ...sagisEvals,
              ...sagisEvaluationWithoutExpertise.filter(
                (item: any) =>
                  !sagisEvals
                    .map((el: any) => el.victimKey)
                    .includes(item.victimKey),
              ), // to-update
              ...reasonWithoutCompensationEvaluations, // to-update
            ],
      priorityClaimReasonId:
        priorityReasonClaimId != 4 &&
        featureService.hasFeature(FEATURES.PRIORITY_CLAIM)
          ? priorityClaimReason(
              [
                ...sagisEvals,
                ...sagisEvaluationWithoutExpertise.filter(
                  (item: any) =>
                    !sagisEvals
                      .map((el: any) => el.victimKey)
                      .includes(item.victimKey),
                ),
              ],
              !isEmpty(get(resolveSagisClaim(policyInfo), 'offeredRisks', []))
                ? get(resolveSagisClaim(policyInfo), 'offeredRisks', [])
                    .map((el: any) => Number(el.riskProvisions))
                    .reduce(
                      (accumulator: any, currentValue: any) =>
                        accumulator + currentValue,
                    )
                : 0,
              listings,
            )
          : undefined,
      isPriorityActive: featureService.hasFeature(FEATURES.PRIORITY_CLAIM),
      provisionBody:
        toUpdate &&
        (jomStatus === STATUS_PENDING || jomStatus === STATUS_REJECTED)
          ? undefined
          : {
              riskID: get(
                resolveSagisClaim(policyInfo),
                'offeredRisks',
                [],
              ).find(
                (element: { riskName: string }) =>
                  element.riskName === rcCoporeal,
              )?.riskId,
              date: moment().toISOString(true),
            },
      nextOfKins:
        toUpdate &&
        (jomStatus === STATUS_PENDING || jomStatus === STATUS_REJECTED)
          ? undefined
          : nextOfKins,
      deceasedVictims: getDeceasedVictim(
        (deceasedVictim as unknown) as VictimType[],
        props.judgementAddClone,
        sharedResponsability as any,
      ),
      isInboxesActive: featureService.hasFeature(
        FEATURES.ATTRIBUTION_INBOXES_MANAGER,
      ),
      //to-add
      invoiceFeeNotes: [],
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      toUpdate,
    };

    if (isContestationDrawerOpen) {
      validationRequest.status = PROCEDURE_STATUSES.OPPOSITION;
      validationRequest.contestation = {
        ...formContestationValues,
        victims: selectedVictims,
        vehicules: selectedVehicles,
        contestationType,
        judgementOnMeritsId: get(
          judgementOnMerits,
          'judgementOnMerits.jom.id',
          '',
        ),
      };
    }
    requestValidateJudgementOnMerits(
      validationRequest,
      successCallBack(toUpdate),
    );
    setIsValidated(isValidated);
    setJomStatus(
      isEmpty(contestationReasons) &&
        isEmpty(correctionalContestationReasons.reasons)
        ? PROCEDURE_STATUSES.VALIDATED_WITHOUT_CONTESTATION
        : PROCEDURE_STATUSES.APPLICATION_ANNULMENT,
    );
  };
  useEffect(() => {
    props.requestGetJudgementAddAppeal(
      claimId,
      PROCEDURE_TYPES.FIRST_INSTANCE,
      props.judiciaryProcessId,
    );
  }, [claimId, props.judiciaryProcessId]);

  const successCallBack = (toUpdate: boolean) => () => {
    !toUpdate
      ? toast.success(
          translate(
            messages.courtManagerValidationDialogSuccessMessage,
            props,
            { lawyer },
          ),
        )
      : toast.success(
          translate(messages.updatedStepSuccessMessage, props, {
            lawyer,
          }),
        );
    openDialogValidation && setOpenDialogValidation(false);
    if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
    } else {
      !toUpdate &&
        featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) &&
        props.setOpenFeeNoteDialog(true);
    }
  };

  const [
    judgementOnMeritsFormDocument,
    setJudgementOnMeritsFormDocument,
  ] = useState({ ...EMPTY_JUDGEMENT_ON_MERITS_DOC });

  const [
    correctionalJudgementOnMeritsForm,
    setCorrectionalJudgementOnMeritsForm,
  ] = useState<any>([]);

  useEffect(() => {
    setjudgementAddClone(cloneDeep(props.judgementAdd));
  }, [props.judgementAdd]);

  useEffect(() => {
    if (!isEmpty(judgementOnMerits)) {
      const suedParties =
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ) &&
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ).map(el => {
          return {
            id: el.id,
            condamnation: el.condamnation,
            suedPartyId: el.suedPartyId,
            isModified: false,
          };
        });
      const responsabilityShares = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        return {
          id: el.id,
          responsibilityShare: el.responsibilityShare,
          isModified: false,
        };
      });
      const civjVictimAccountings = civilJudgements
        .flatMap((item: any) => item.civjacce)
        .filter((el: any) => !!el.victim);

      const medicalExpertises = judgementOnMerits['judgementOnMerits']['jom'][
        'civjs'
      ].map(el => {
        const medExpertises = el['civjmede'].map((item: any) => {
          const accountingExpertise =
            civjVictimAccountings.find(el => el.victimId === item.victimId) ||
            {};
          return {
            id: item.id,
            compensationAmount: item.compensationAmount,
            provisionalExecution: item.provisionalExecution,
            victimId: item?.victimId,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            evaluationAmount: get(
              accountingExpertise,
              'evaluationAmount',
              null,
            ),
          };
        });
        return {
          id: el.id,
          medExpertises: [...medExpertises],
        };
      });
      const accountingExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const accExpertises = el['civjacce'].map((item: any) => {
          return {
            id: item.id,
            evaluationAmount: item.evaluationAmount,
            calculatedRevenue: item.calculatedRevenue,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            victimId: get(item, 'victimId', null),
            vehiculeId: get(item, 'vehiculeId', null),
          };
        });
        return {
          id: el.id,
          accExpertises: [...accExpertises],
        };
      });
      const mechanicalExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const mechanicalExpertise = get(el, 'civjmece', []).map((item: any) => {
          return {
            id: item.id,
            damageAmount: item.damageAmount,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgmentAddDocumentId:
              item?.expertiseJudgmentAddDocumentId,
            vehiculeId: item?.vehiculeId,
          };
        });
        return {
          id: el.id,
          mechanicalExpertise: [...mechanicalExpertise],
        };
      });
      suedParties && setCorrectionalJudgementOnMeritsForm([...suedParties]);
      setCivilJudgementOnMeritsForm([...responsabilityShares]);
      setCivilJudgementOnMeritsFormMedicalExpertise([...medicalExpertises]);
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...accountingExpertises,
      ]);
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...mechanicalExpertises,
      ]);
    } else {
      props.requestGetJudgementAdd(
        claimId,
        PROCEDURE_TYPES.FIRST_INSTANCE,
        props.judiciaryProcessId,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [judgementOnMerits, props.judgementAdd, props.judiciaryProcessId]);

  const handleCorrectionalCondamnationChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.condamnation = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };

  const handleMedExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident?: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMedicalExpertiseData = [
      ...civilJudgementOnMeritsFormMedicalExpertise,
    ];
    const civilJudgementMed = civilJudgementOnMeritsFormMedicalExpertise.find(
      (item: any) => item.id === id,
    );
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const medExp =
      get(civilJudgementMed, 'medExpertises', []).find(
        (item: any) => item.id === expertiseId,
      ) || {};
    const accountingExp = filterJudgementAddDocumentsByDate(
      allJudgementAddDocuments,
      judgementOnMerits,
    )
      .map((el: any) => {
        const victimExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.victims)
          .find((victim: VictimType) => victim.id === incident.id);
        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            victimExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          victimId: get(victimExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);
    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    if (isEmpty(medExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMedicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MEDICAL,
        incidentType,
        incident,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id'),
          civilJudgements,
          `${get(accountingExp, 'victimId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMedicalExpertise(
        civilJudgementOnMeritsFormMedicalExpertiseData,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(medExp)) {
      const civjWithoutCompensation = [...civjvmRequest];
      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          medExp,
          type,
          e,
          civjWithoutCompensation,
          setCivjvmRequest,
          accountingExp,
        );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMedicalExpertise([
        ...civilJudgementOnMeritsFormMedicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMed.id,
        ),
        {
          id: civilJudgementMed.id,
          medExpertises: [
            ...civilJudgementMed.medExpertises.filter(
              (el: any) => el.id !== medExp.id,
            ),
            {
              ...medExp,
              id: medExp.id,
              compensationAmount:
                type === 0
                  ? e.target.value.replace(',', '.')
                  : medExp.compensationAmount,
              evaluationAmount:
                type === 2
                  ? e.target.value.replace(',', '.')
                  : medExp.evaluationAmount,
              provisionalExecution:
                type === 1
                  ? e.target.value.replace(',', '.')
                  : medExp.provisionalExecution,
            },
          ],
        },
      ]);
    }
  };

  const handleAccExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident?: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgement = civilJudgementOnMeritsFormAccountingExpertise.find(
      (item: any) => item.id === id,
    );
    const civilJudgementData = [...civilJudgements];
    const accExp =
      civilJudgement.accExpertises.find(
        (item: any) => item.id === expertiseId,
      ) || {};
    if (isEmpty(accExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormAccountingExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
        incidentType,
        incident,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(accExp)) {
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...civilJudgementOnMeritsFormAccountingExpertise.filter(
          (el: any) => el.id !== civilJudgement.id,
        ),
        {
          id: civilJudgement.id,
          accExpertises: [
            ...civilJudgement.accExpertises.filter(
              (el: any) => el.id !== accExp.id,
            ),
            {
              ...accExp,
              id: accExp.id,
              evaluationAmount:
                type === 0
                  ? e.target.value.replace(',', '.')
                  : accExp.evaluationAmount,
              provisionalExecution:
                type === 1
                  ? e.target.value.replace(',', '.')
                  : accExp.provisionalExecution,
              calculatedRevenue:
                type === 2
                  ? e.target.value.replace(',', '.')
                  : accExp.calculatedRevenue,
            },
          ],
        },
      ]);
    }
  };

  const handleMechanicalExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMechanicalExpertiseData = [
      ...civilJudgementOnMeritsFormMechanicalExpertise,
    ];
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const civilJudgementMec = civilJudgementOnMeritsFormMechanicalExpertiseData.find(
      (item: any) => item.id === id,
    );

    const accountingExp = filterJudgementAddDocumentsByDate(
      allJudgementAddDocuments,
      judgementOnMerits,
    )
      .map((el: any) => {
        const vehicleExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.vehicules)
          .find((vehicle: any) => vehicle.id === incident.id);

        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            vehicleExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          vehiculeId: get(vehicleExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);

    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    const meceExp = civilJudgementMec.mechanicalExpertise.find(
      (item: any) => item.id === expertiseId,
    );
    if (isEmpty(meceExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMechanicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MECHANICAL,
        incidentType,
        incident,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id'),
          civilJudgements,
          `${get(accountingExp, 'vehiculeId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMechanicalExpertise(
        civilJudgementOnMeritsFormMechanicalExpertiseData,
      );

      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
    } else if (!isEmpty(meceExp)) {
      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        updateVehicleAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          meceExp,
          type,
          e,
          accountingExp,
        );

      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...civilJudgementOnMeritsFormMechanicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMec.id,
        ),
        {
          id: civilJudgementMec.id,
          mechanicalExpertise: [
            ...civilJudgementMec.mechanicalExpertise.filter(
              (el: any) => el.id !== meceExp.id,
            ),
            {
              ...meceExp,
              id: meceExp.id,
              damageAmount: type
                ? meceExp.damageAmount
                : e.target.value.replace(',', '.'),
              provisionalExecution: !type
                ? meceExp.provisionalExecution
                : e.target.value.replace(',', '.'),
            },
          ],
        },
      ]);
    }
  };

  const [jomStatus, setJomStatus] = useState<string>(
    get(judgementOnMerits, 'judgementOnMerits.status', ''),
  );

  const handleCivilResponsabilityShareChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = civilJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.responsibilityShare = e.target.value.replace(',', '.');
    }
    setCivilJudgementOnMeritsForm([...civilJudgementOnMeritsForm]);
    setResponsibilityRate(e.target.value.replace(',', '.'));
  };
  useDeepCompareEffect(() => {
    if (!isEmpty(props.judgementAdd) && !isEmpty(props.judgementAddAppeal)) {
      const judgementAddDocuments = get(
        props.judgementAdd,
        'judgementAddDocuments',
        [],
      );
      const victimkeys = uniq(getVictimKeys(judgementAddDocuments, false));

      props.requestGetDahirAmount(
        [
          ...victimkeys,
          ...get(
            get(
              props.judgementAddAppeal,
              'judgementAddDocuments.[0].expertises',
              [],
            ).filter((el: any) => el.expertiseId === 1),
            '[0].victims',
            [],
          ).map((el: any) => el.victimKey),
          ...get(
            get(
              props.judgementAddAppeal,
              'judgementAddDocuments.[0].expertises',
              [],
            ).filter((el: any) => el.expertiseId === 2),
            '[0].victims',
            [],
          ).map((el: any) => el.victimKey),
        ],
        [
          ...without(
            uniq(
              victims
                .filter((v: any) => v['injuryPostKey'] === INJURY_POST_DECEASED)
                .map((v: any) => v.victimKey),
            ),
            null,
            '',
          ),
        ],
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judgementAdd, props.judgementAddAppeal]);

  const handleCorrectionalSelectChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.suedPartyId = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };
  const validateDesceasedVictim = shouldValidateDesceasedVictims(
    deceasedVictim,
    get(listings, 'civilJudgementVictimReason', []),
    get(judgementOnMeritsRequest, 'jmv', []),
    props,
  );
  const allJudgementDocuments = useMemo(
    () =>
      resolveJudgementAddAppeal(
        getJudgementAddDocuments(
          props.judgementAddDocuments,
          get(props.judgementAddAppeal, 'judgementAddDocuments', []),
          judgementOnMerits,
        ),
        false,
        null,
      ),
    [props.judgementAddDocuments, props.judgementAddAppeal, judgementOnMerits],
  );

  const validateCivilJudgements = validateCivilJudgementsOnRecap(
    filterExpertises(
      formatExpertisesWithExpertReport(
        allJudgementDocuments,
        allVictimExpertises,
        allVehiculeExpertises,
      ),
    ),
    formatExpertisesWithExpertReport(
      allJudgementDocuments,
      allVictimExpertises,
      allVehiculeExpertises,
    ),
    judgement,
    civilJudgementOnMeritsFormMedicalExpertise,
    civilJudgementOnMeritsFormAccountingExpertise,
    civilJudgementOnMeritsFormMechanicalExpertise,
    civjvmRequest,
    get(judgementOnMeritsRequest, 'civjVehicle', []),
    get(listings, 'civilJudgementVictimReason', []),
    get(judgementOnMeritsRequest, 'civjs', []),
    get(judgementOnMeritsRequest, 'civjvm', {}),
    isCJDisabled,
    judgementOnMerits,
  );

  const resolveDropDownMenuElements = () => {
    const updateJom =
      featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
      props.isManager &&
      jomStatus !== PROCEDURE_STATUSES.PENDING
        ? ({
            title: translate(messages.updateJom, props),
            action: () => handleValidateJudgementOnMerits(true, true)(),
            disabled:
              (!featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
                !props.isManager) ||
              disableOnValidationButton(
                judgementOnMeritsInfoForm,
                validateDesceasedVictim,
                getAllBeneficiaries(deceasedVictim),
                validateCivilJudgements,
                sharedResponsability,
                civilJudgementOnMeritsFormMedicalExpertise,
                civilJudgementOnMeritsFormAccountingExpertise,
                civilJudgementOnMeritsFormMechanicalExpertise,
                get(listings, 'civilJudgementVictimReason', []),
                get(judgementOnMeritsRequest, 'civjs', []),
                getVictims(),
                civjvmRequest,
                allJudgementDocuments,
              ),
          } as any)
        : {};
    const dropdown =
      jomStatus === PROCEDURE_STATUSES.PENDING ||
      jomStatus === PROCEDURE_STATUSES.REJECTED
        ? [
            {
              title: translate(messages.validateButton, props),
              action: () =>
                jomStatus === PROCEDURE_STATUSES.REJECTED &&
                featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)
                  ? setOpenDialogValidation(true)
                  : handleValidateJudgementOnMerits(false, false)(),
              disabled:
                !isEmpty(contestationReasons) ||
                isExpertReportNotValidated ||
                !isEmpty(correctionalContestationReasons.reasons) ||
                isBeneficiaryNotEmpty(beneficiaryContestationReasons) ||
                disableOnValidationButton(
                  judgementOnMeritsInfoForm,
                  validateDesceasedVictim,
                  getAllBeneficiaries(deceasedVictim),
                  validateCivilJudgements,
                  sharedResponsability,
                  civilJudgementOnMeritsFormMedicalExpertise,
                  civilJudgementOnMeritsFormAccountingExpertise,
                  civilJudgementOnMeritsFormMechanicalExpertise,
                  get(listings, 'civilJudgementVictimReason', []),
                  get(judgementOnMeritsRequest, 'civjs', []),
                  getVictims(),
                  civjvmRequest,
                  allJudgementAddDocuments,
                ),
            },
            {
              title: translate(messages.reject, props),
              action: () => setIsRejectionDialogOpen(true),
            },
          ]
        : [
            {
              title: translate(messages.contestationDrawer, props),
              action: () => setIsContestationDrawerOpen(true),
              disabled:
                isEmpty(contestationReasons) &&
                isEmpty(correctionalContestationReasons.reasons) &&
                !isBeneficiaryNotEmpty(beneficiaryContestationReasons),
            },
          ];

    return !isEmpty(updateJom) ? [...dropdown, updateJom] : dropdown;
  };

  const hasValidator = showValidator(
    get(judgementOnMerits, 'judgementOnMerits.validator', ''),
    props.isManager,
  );
  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const successCallBackArchive = () => {
    toast.success(translate(messages.archiveSuccessToast, props));
  };
  const handleValidateArchiveJudgement = () => {
    props.requestArchiveJudgement &&
      props.requestArchiveJudgement(
        {
          claimId: claimId,
          archiveReason: archiveReason,
          judgementId: get(judgementOnMerits, 'judgementOnMerits.id'),
          procedureType: get(
            judgementOnMerits,
            'judgementOnMerits.procedureType',
          ),
          judiciaryProcessId: get(
            judgementOnMerits,
            'judgementOnMerits.judiciaryProcessId',
          ),
        },
        successCallBackArchive,
      );
  };

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
    setArchiveReason((e.target.value as unknown) as string);
  };
  return (
    <Container id="judgement-on-merits-wrapper">
      {userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
        !props.isConsultation &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISJUDGEMENTARCHIVEMANAGER) &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              style={{ ...(StyledSecondaryButton as any) }}
              data-testId={'reject-transaction-button'}
              onClick={handleOpenDialog}
            >
              <Grid container direction="row" alignItems="center">
                <Grid item>
                  <img
                    src={deleteIcon}
                    style={{ marginTop: '4px' }}
                    alt="delete"
                  />
                </Grid>
                <Grid item>
                  <span>
                    {translate(messages.archiveJudgementTitle, props)}
                  </span>
                </Grid>
              </Grid>
            </Button>
          </div>
        )}
      {
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      }
      {
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
          {get(judgementOnMerits, 'judgementOnMerits.creator', '')
            ? translate(messages.creatorTitle, props, {
                lawyer: get(judgementOnMerits, 'judgementOnMerits.creator', ''),
              })
            : ''}
        </span>
      }
      {hasValidator && jomStatus !== PROCEDURE_STATUSES.PENDING && (
        <ValidatorRecap
          validator={get(judgementOnMerits, 'judgementOnMerits.validator', '')}
        />
      )}
      <UpdateStepRecap
        updatedBy={get(judgementOnMerits, 'judgementOnMerits.updatedBy', '')}
      />

      <div>
        <div className="judgement-on-merits-title">
          {translate(messages.AppealOnMeritsInfoTitle, props)}
          {get(judgementOnMerits, 'judgementOnMerits.rejectionReason', '') &&
            jomStatus === PROCEDURE_STATUSES.REJECTED &&
            !isValidated && (
              <span style={{ marginLeft: '10px', color: COLORS.RED }}>
                {translate(messages.rejectedTitle, props)}
                {` : ${get(
                  judgementOnMerits,
                  'judgementOnMerits.rejectionReason',
                )}`}
              </span>
            )}
          {isExpertReportNotValidated && (
            <span style={{ marginLeft: '10px', color: COLORS.RED }}>
              {translate(messages.expertReportNotValidated, props)}
            </span>
          )}
          {(!isEmpty(
            difference(
              uniq(getVictimIds(props.judgementAddDocuments)),
              get(expertiseReport, 'victimExpertises', []).map(
                (el: any) => el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              ),
            ),
          ) ||
            !isEmpty(
              difference(
                uniq(getVehiculeIds(props.judgementAddDocuments)),
                get(expertiseReport, 'vehiculeExpertises', []).map(
                  (el: any) => el[VEHICULE_EXPERTISE_FIELDS.VEHICULE_ID],
                ),
              ),
            )) &&
            get(judgementOnMerits, 'judgementOnMerits.status') ===
              'PENDING' && (
              <span style={{ marginLeft: '10px', color: COLORS.RED }}>
                {translate(messages.expertReportNotExist, props)}
              </span>
            )}
        </div>
        {!isContested(judgementOnMerits) && !isEmpty(judgementOnMerits) && (
          <JudgementOnMeritsForm
            judgementOnMeritsInfoForm={judgementOnMeritsInfoForm}
            setJudgementOnMeritsInfoForm={setJudgementOnMeritsInfoForm}
            judgementOnMerits={judgementOnMerits}
            isReadOnly={isMonitoringCourtManager()}
            judgementAddDocuments={
              isEmpty(props.judgementAddDocuments)
                ? get(props.judgementAddAppeal, 'judgementAddDocuments', [])
                : props.judgementAddDocuments
            }
          />
        )}
        {isContested(judgementOnMerits) && !isEmpty(judgementOnMerits) && (
          <JudgementOnMeritsInfo
            judgementOnMeritsInfo={judgementOnMeritsInfo}
            setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
            judgementOnMerits={judgementOnMerits}
            judgementAddDocuments={props.judgementAddDocuments}
            judgementAdd={props.judgementAdd}
          />
        )}
        {!isEmpty(judgementOnMerits) &&
          get(
            judgementOnMerits['judgementOnMerits']['jom']['cj'],
            'suedPartys',
          ) && (
            <>
              <div className="judgement-on-merits-title">
                {translate(messages.correctionalJudgementTitle, props)}
              </div>
              <div className="correctional-judgement">
                <div>
                  {!isContested(judgementOnMerits) &&
                    !isEmpty(judgementOnMerits) &&
                    get(
                      judgementOnMerits['judgementOnMerits']['jom']['cj'],
                      'suedPartys',
                    ) &&
                    get(
                      judgementOnMerits['judgementOnMerits']['jom']['cj'],
                      'suedPartys',
                    ).map((el: ISuedPartyType, index: number) => (
                      <>
                        <FormContainer>
                          <div className="condamnation-textfield">
                            <TextField
                              label={translate(
                                { ...messages.condamnationFieldTitle },
                                props,
                              )}
                              onChange={handleCorrectionalCondamnationChange(
                                el?.id,
                              )}
                              value={
                                correctionalJudgementOnMeritsForm.find(
                                  (item: any) => item.id === el.id,
                                )
                                  ? correctionalJudgementOnMeritsForm.find(
                                      (item: any) => item.id === el.id,
                                    ).condamnation
                                  : ''
                              }
                            />
                          </div>
                          <FormControl className="input-fields">
                            <InputLabel>
                              {translate(messages.suedPartyTitle, props)}
                            </InputLabel>
                            <Select
                              value={
                                correctionalJudgementOnMeritsForm.find(
                                  (item: any) => item.id === el.id,
                                )
                                  ? correctionalJudgementOnMeritsForm.find(
                                      (item: any) => item.id === el.id,
                                    ).suedPartyId
                                  : ''
                              }
                              onChange={handleCorrectionalSelectChange(el?.id)}
                            >
                              {!isEmpty(get(listings, 'suedParty', [])) &&
                                listings.suedParty.map(suedParty => (
                                  <MenuItem
                                    value={suedParty.id}
                                    key={suedParty.id}
                                  >
                                    {suedParty.title}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </FormContainer>
                      </>
                    ))}
                  {isContested(judgementOnMerits) &&
                    !isEmpty(judgementOnMerits) &&
                    judgementOnMerits['judgementOnMerits']['jom'][
                      'cj'
                    ].suedPartys.map((el: ISuedPartyType, index: number) => (
                      <>
                        <FormContainer>
                          <div className="condamnation-textfield">
                            <TextField
                              label={translate(
                                { ...messages.condamnationFieldTitle },
                                props,
                              )}
                              defaultValue={el.condamnation}
                              InputProps={{ readOnly: true }}
                            />
                          </div>
                          <FormControl className="input-fields">
                            <InputLabel>
                              {translate(messages.suedPartyTitle, props)}
                            </InputLabel>
                            <Select value={el.suedPartyId} disabled={true}>
                              {!isEmpty(get(listings, 'suedParty', [])) &&
                                listings.suedParty.map(suedParty => (
                                  <MenuItem
                                    value={suedParty.id}
                                    key={suedParty.id}
                                  >
                                    {suedParty.title}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </FormContainer>
                      </>
                    ))}
                </div>
                <CorrectionalJudgementManagerRecap
                  listings={listings}
                  judgementOnMerits={judgementOnMerits}
                  correctionalContestationReasons={
                    correctionalContestationReasons
                  }
                  setCorrectionalContestationReasons={
                    setCorrectionalContestationReasons
                  }
                  isContested={isContested(judgementOnMerits)}
                  isConsultation={props.isConsultation}
                />
              </div>
            </>
          )}
        {!isEmpty(civilJudgementVictims) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.injuredVictim, props)}
            </div>
            <div className="judgement-add-doc">
              {civjvmRequest
                .filter((item: any) => !item.expertiseJudgementAddDocumentId)
                .map((civjvm: any) => {
                  return (
                    <InjuredVictimsRecap
                      listings={listings}
                      judgementOnMeritsRequest={judgementOnMeritsRequest}
                      isManager={userPrivileges.userHasPrivilege(
                        PRIVILEGES.ISCOURTMANAGER,
                      )}
                      modeType={MODE_TYPES.RECAP}
                      judgement={judgement}
                      setJudgement={setJudgement}
                      judgementForNonCompensation={
                        JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION
                      }
                      civjvms={civjvmRequest.filter(
                        (item: any) => !item.expertiseJudgementAddDocumentId,
                      )}
                      civjWithNonCompensation={civjvm}
                      handleCivJvmChange={handleCivJvmChange}
                      judgementOnMerits={judgementOnMerits}
                      sagisVictimInfo={props.sagisVictimInfo}
                      victim={{
                        id: get(civjvm, 'victimId'),
                        ...get(civjvm, 'victim', {}),
                      }}
                      expertiseJudgementAddDocumentId={get(
                        civjvm,
                        'expertiseJudgementAddDocumentId',
                      )}
                      civj={{}}
                      setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                      civjvmRequest={civjvmRequest}
                      setCivjvmRequest={setCivjvmRequest}
                      setCivilJudgements={setCivilJudgements}
                      civilJudgements={civilJudgements}
                      isDisabled={false}
                      dahirAmount={dahirAmountByVictimKey}
                    />
                  );
                })}
            </div>
          </>
        )}
        {!isEmpty(judgementOnMerits) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.sharedResponsability, props)}
            </div>
            <div className="shared-responsability">
              <TextField
                name={'sharedResponsability'}
                data-testId="shared-responsability"
                label={translate(messages.sharedResponsability, props)}
                value={sharedResponsability}
                onChange={handleChangeSharedResponsability}
                className="shared-responsability-field"
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        { ...messages.responsibiltySharePercentage },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
                type="number"
                error={disableSharedResponsibility(
                  sharedResponsability,
                  beneficiaries,
                  get(judgementOnMeritsRequest, 'civjs', []),
                )}
                helperText={
                  disableSharedResponsibility(
                    sharedResponsability,
                    beneficiaries,
                    get(judgementOnMeritsRequest, 'civjs', []),
                  ) && translate(messages.validateRequiredField, props)
                }
              />
            </div>
          </>
        )}
        {!isDeceasedVictimsOnly(victims) && !props.isConsultation && (
          <CivilJudgementForm
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            dahirAmount={dahirAmountByVictimKey}
            judgementOnMerits={judgementOnMerits}
            judgementAddDocuments={props.judgementAddDocuments}
            isDisabled={isCJDisabled}
            setIsDisabled={setIsCJDisabled}
            judgementAddAppeal={props.judgementAddAppeal}
            allJudgementDocuments={filteredJaddDocuments}
            isAppeal
            sharedResponsability={sharedResponsability}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            victims={victims}
            injuredVictims={getInjuredVictims(
              getJudgementAddDocuments(
                props.judgementAddDocuments,
                [],
                judgementOnMerits,
              ),
              victims,
            )}
            isMultiple={isMultiple}
            listings={listings}
            setJudgement={setJudgement}
            judgement={judgement}
            expertiseReport={{
              victimExpertises: allVictimExpertises,
              vehiculeExpertises: allVehiculeExpertises,
            }}
          />
        )}
        {!isEmpty(judgementOnMerits) &&
          filterAccountingCivjs(
            civilJudgements,
            civjvmRequest,
            get(judgementOnMeritsRequest, 'civjVehicle', []),
            allJudgementAddDocuments,
          ).map((civilJudgement: any, index: any) => (
            <>
              <div className="judgement-add-doc-title">
                {translate(messages.judgementCivilRecap, props, {
                  index: index + 1,
                  date: props.intl.formatDate(civilJudgement.createdAt, {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }),
                })}
              </div>
              <div key={civilJudgement.id} className="judgement-add-doc">
                <CivilJudgementRecap
                  isAppeal
                  judgementAddDocument={getAppealAddDocument(
                    civilJudgement,
                    props.judgementAddDocuments,
                    props.judgementAddAppeal,
                    allVictimExpertises,
                    allVehiculeExpertises,
                  )}
                  contestationReasons={contestationReasons}
                  setContestationReasons={setContestationReasons}
                  listings={listings}
                  civilJudgement={civilJudgement}
                  isManager={
                    userPrivileges.userHasPrivilege(
                      PRIVILEGES.ISCOURTMANAGER,
                    ) && !props.isConsultation
                  }
                  isContested={isContested(judgementOnMerits)}
                  dahirAmount={
                    dahirAmountByVictimKey as { [key: string]: number }
                  }
                  responsabilityShareValue={
                    civilJudgementOnMeritsForm.find(
                      (item: any) => item.id === civilJudgement.id,
                    )
                      ? civilJudgementOnMeritsForm.find(
                          (item: any) => item.id === civilJudgement.id,
                        ).responsibilityShare
                      : ''
                  }
                  handleCivilResponsabilityShareChange={handleCivilResponsabilityShareChange(
                    civilJudgement.id,
                  )}
                  medicalExpertise={civilJudgementOnMeritsFormMedicalExpertise.find(
                    (item: any) => item.id === civilJudgement.id,
                  )}
                  handleMedExpertiseChange={handleMedExpertiseChange(
                    civilJudgement.id,
                  )}
                  accountingExpertise={civilJudgementOnMeritsFormAccountingExpertise.find(
                    (item: any) => item.id === civilJudgement.id,
                  )}
                  handleAccExpertiseChange={handleAccExpertiseChange(
                    civilJudgement.id,
                  )}
                  civilJudgementMechanicalExpertise={civilJudgementOnMeritsFormMechanicalExpertise.find(
                    (item: any) => item.id === civilJudgement.id,
                  )}
                  handleMechanicalExpertiseChange={handleMechanicalExpertiseChange(
                    civilJudgement.id,
                  )}
                  sagisVictimInfo={props.sagisVictimInfo}
                  sagisOpposingParties={props.sagisOpposingParties}
                  judgementOnMeritsRequest={judgementOnMeritsRequest}
                  setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                  judgement={judgement}
                  setJudgement={setJudgement}
                  civjvmRequest={civjvmRequest}
                  handleCivJvmChange={handleCivJvmChange}
                  handleCivjVehicleChange={handleCivjVehicleChange}
                  judgementOnMerits={judgementOnMerits}
                  civilJudgementOnMeritsFormAccountingExpertise={
                    civilJudgementOnMeritsFormAccountingExpertise
                  }
                  setCivilJudgementOnMeritsFormAccountingExpertise={
                    setCivilJudgementOnMeritsFormAccountingExpertise
                  }
                  civilJudgementOnMeritsFormMedicalExpertise={
                    civilJudgementOnMeritsFormMedicalExpertise
                  }
                  setCivilJudgementOnMeritsFormMedicalExpertise={
                    setCivilJudgementOnMeritsFormMedicalExpertise
                  }
                  civilJudgementOnMeritsFormMechanicalExpertise={
                    civilJudgementOnMeritsFormMechanicalExpertise
                  }
                  setCivilJudgementOnMeritsFormMechanicalExpertise={
                    setCivilJudgementOnMeritsFormMechanicalExpertise
                  }
                  setCivjvmRequest={setCivjvmRequest}
                  civilJudgements={civilJudgements}
                  setCivilJudgements={setCivilJudgements}
                  expertiseReport={{
                    victimExpertises: allVictimExpertises,
                    vehiculeExpertises: allVehiculeExpertises,
                  }}
                  judgementAddDocuments={formatExpertisesWithExpertReport(
                    allJudgementAddDocuments,
                    allVictimExpertises,
                    allVehiculeExpertises,
                  )}
                />
              </div>
            </>
          ))}
        {(!isEmpty(
          getBeneficiaries(
            props.judgementAddClone,
            get(judgementOnMerits, 'judgementOnMerits.jom.id'),
          ),
        ) ||
          !isEmpty(deceasedVictimInJom)) && (
          <DeceasedVictim
            isManager={
              userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
              !props.isConsultation
            }
            isRecap={true}
            beneficiairies={beneficiaries}
            judgementAddAppeal={props.judgementAddAppeal}
            judgementAdd={
              isEmpty(props.judgementAddClone)
                ? judgementAddClone
                : props.judgementAddClone
            }
            listing={listings}
            desceasedVictims={deceasedVictim}
            handleChangeDesceasedVictim={handleChangeDesceasedVictim}
            handleChangeBeneficiaries={setBeneficiaries}
            RecapInfo={judgementOnMerits['beneficiaries']}
            beneficiaryContestationReasons={beneficiaryContestationReasons}
            setBeneficiaryContestationReasons={
              setBeneficiaryContestationReasons
            }
            isContested={isContested(judgementOnMerits)}
            dahirAmount={dahirAmountByVictimKey}
            currentJudiciaryProcess={currentJudiciaryProcess}
            victims={victims}
            judgementOnMerits={judgementOnMerits}
            allVictims={getVictims()}
            jomDeceasedVictims={jomDeceasedVictims}
            isMultiple={isMultiple}
            sharedResponsability={sharedResponsability}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            dahirAmountByVictimKey={dahirAmountByVictimKey}
            lossDate={get(claimRecap, 'claim.lossDate')}
          />
        )}
        <div className="judgement-on-merits-title">
          {translate(messages.judgementOnMeritsAdditionalInfo, props)}
        </div>
        {!isContested(judgementOnMerits) && !isEmpty(judgementOnMerits) && (
          <AdditionalInfoJudgementOnMeritForm
            additionalJudgementOnMeritsInfoForm={
              additionalJudgementOnMeritsInfoForm
            }
            judgementOnMeritsFormDocument={judgementOnMeritsFormDocument}
            setJudgementOnMeritsFormDocument={setJudgementOnMeritsFormDocument}
            setAdditionalJudgementOnMeritsInfoForm={
              setAdditionalJudgementOnMeritsInfoForm
            }
            judgementOnMerits={judgementOnMerits}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            handleJudgementOnMeritsDocChange={() => {}}
            uploadedDocument={uploadedDocument}
            setDocumentId={setDocumentId}
            documentId={documentId}
            requestAddJudgementOnMeritsSupportDocument={
              props.requestAddJudgementOnMeritsSupportDocument
            }
            claimId={claimId}
            claimNumber={claimNumber}
            isAppeal
            isCivilProceeding={isCivilProceeding}
            isManager={
              userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
              !props.isConsultation
            }
            isAssignedLawyer={props.isAssignedLawyer}
            isCreator={props.isAssignedLawyer}
            requestMakeDecisionSupportDocument={
              props.requestMakeDecisionSupportDocument
            }
            judiciaryProcessId={get(
              judgementOnMerits['judgementOnMerits'],
              'judiciaryProcessId',
            )}
            claim={claim}
            imagineDocuments={props.imagineDocuments}
            policyInfo={policyInfo}
            listings={listings}
            isConsultation={props.isConsultation}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
        {isContested(judgementOnMerits) &&
          !isEmpty(judgementOnMerits) &&
          userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) && (
            <AdditionalInfoJudgementOnMerit
              judgementOnMeritsInfo={judgementOnMeritsInfo}
              setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
              judgementOnMerits={judgementOnMerits}
              resetUploadedDocument={resetUploadedDocument}
              uploadDocument={uploadDocument}
              handleJudgementOnMeritsDocChange={() => {}}
              uploadedDocument={uploadedDocument}
              setDocumentId={setDocumentId}
              documentId={documentId}
              isAssignedLawyer={props.isAssignedLawyer}
              requestAddJudgementOnMeritsSupportDocument={
                props.requestAddJudgementOnMeritsSupportDocument
              }
              claim={claim}
              requestMakeDecisionSupportDocument={
                props.requestMakeDecisionSupportDocument
              }
              judiciaryProcessId={get(
                judgementOnMerits['judgementOnMerits'],
                'judiciaryProcessId',
              )}
              imagineDocuments={props.imagineDocuments}
              policyInfo={policyInfo}
              listings={listings}
              isConsultation={props.isConsultation}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          )}
        {userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
          !props.isConsultation && (
            <div>
              <section className="submit-form">
                <SecondaryButton
                  title={translate(messages.goBackButton, props)}
                  data-testid="go-back"
                />
                <DropDownDecisionMenu
                  setDropDown={setDropDown}
                  dropDown={dropDown}
                  height="46"
                  label={translate(messages.managerDecisionTitle, props)}
                  menuElements={resolveDropDownMenuElements()}
                />
              </section>

              {featureService.hasFeature(
                FEATURES.JUDGEMENT_ON_MERITS_CONTESTATION,
              ) ? (
                <div>
                  <SahamDrawer
                    open={isContestationDrawerOpen}
                    handleToggleDrawer={() =>
                      setIsContestationDrawerOpen(false)
                    }
                    title={translate(messages.contestationDrawerTitle, props)}
                    confirmButtonTitle={translate(
                      messages.validateButton,
                      props,
                    )}
                    isDisplayCancelButton
                    isDisplayCloseButton
                    handleValidateDrawer={handleValidateJudgementOnMerits(
                      true,
                      false,
                    )}
                  >
                    <FormContainer>
                      <FormControl className="formEl">
                        <InputLabel>
                          {translate(
                            messages.judgementOnMeritsContestationType,
                            props,
                          )}
                        </InputLabel>
                        <Select
                          onChange={handleFormChange(CONTESTATION.TYPE)}
                          name={CONTESTATION.TYPE}
                          value={get(
                            formContestationValues,
                            [CONTESTATION.TYPE],
                            '',
                          )}
                        >
                          {get(
                            listings,
                            'judgementOnMeritsContestationTypes',
                            [],
                          )
                            .filter(
                              (el: any) =>
                                (el.displayedFor === PROCEDURE_TYPES.APPEAL ||
                                  isNil(el.displayedFor)) &&
                                el.isVisible,
                            )
                            .map((type: Config) => (
                              <MenuItem value={type.id} key={type.id}>
                                {type.title}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </FormContainer>
                    {formContestationValues[CONTESTATION.TYPE] === 2 && (
                      <FormContainer>
                        <FormControl className="formEl">
                          <InputLabel>
                            {translate(
                              messages.judgementOnMeritsContestationWithdrawalReason,
                              props,
                            )}
                          </InputLabel>
                          <Select
                            onChange={handleFormChange(
                              CONTESTATION.WITHDRAWALREASON,
                            )}
                            name={CONTESTATION.WITHDRAWALREASON}
                            value={get(
                              formContestationValues,
                              [CONTESTATION.WITHDRAWALREASON],
                              '',
                            )}
                          >
                            {get(
                              listings,
                              'judgementOnMeritsContestationWithdrawalReasons',
                              [],
                            ).map((type: Config) => (
                              <MenuItem value={type.id} key={type.id}>
                                {type.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </FormContainer>
                    )}
                    <FormContainer>
                      <FormControl className="formEl">
                        <InputLabel>
                          {translate(
                            messages.judgementOnMeritsContestationOwner,
                            props,
                          )}
                        </InputLabel>
                        <Select
                          onChange={handleFormChange(CONTESTATION.OWNER)}
                          name={CONTESTATION.OWNER}
                          value={get(
                            formContestationValues,
                            [CONTESTATION.OWNER],
                            '',
                          )}
                        >
                          {get(
                            listings,
                            'judgementOnMeritsContestationOwners',
                            [],
                          ).map((type: Config) => (
                            <MenuItem value={type.id} key={type.id}>
                              {type.title}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </FormContainer>
                    <FormContainer>
                      <FormControl className="formEl">
                        <InputLabel>
                          {translate(
                            messages.judgementOnMeritsContestationAgainst,
                            props,
                          )}
                        </InputLabel>
                        <Select
                          onChange={handleFormChange(CONTESTATION.AGAINST)}
                          name={CONTESTATION.AGAINST}
                          value={get(
                            formContestationValues,
                            [CONTESTATION.AGAINST],
                            '',
                          )}
                        >
                          <MenuItem value={CONTESTATION_AGAINST.VICTIM} key={0}>
                            {CONTESTATION_AGAINST.VICTIM}
                          </MenuItem>
                          <MenuItem
                            value={CONTESTATION_AGAINST.VEHICLE}
                            key={1}
                          >
                            {CONTESTATION_AGAINST.VEHICLE}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </FormContainer>
                    {formContestationValues[CONTESTATION.AGAINST] ===
                      CONTESTATION_AGAINST.VICTIM && (
                      <FormContainer>
                        <FormGroup>
                          {filterVictim(victims).map(
                            (victim: VictimType, index: number) => (
                              <FormControlLabel
                                key={index}
                                control={
                                  <Checkbox
                                    data-testid="checkboxId"
                                    checked={IsVictimChecked(
                                      victim.id as any,
                                      selectedVictims,
                                    )}
                                    color="primary"
                                    onChange={handleVictimChangeCheckBox(
                                      victim.id as any,
                                    )}
                                  />
                                }
                                label={
                                  featureService.hasFeature(
                                    FEATURES.MIGRATION_CLAIM_INFO,
                                  )
                                    ? `${get(
                                        getVictimFromSagisInfo(
                                          get(victim, 'victimKey'),
                                          props.sagisVictimInfo,
                                        ),
                                        'victimFirstName',
                                        '',
                                      )} ${get(
                                        getVictimFromSagisInfo(
                                          get(victim, 'victimKey'),
                                          props.sagisVictimInfo,
                                        ),
                                        'victimLastName',
                                        '',
                                      )}`
                                    : getVictimFullName(victim)
                                }
                              />
                            ),
                          )}
                        </FormGroup>
                      </FormContainer>
                    )}
                    {formContestationValues[CONTESTATION.AGAINST] ===
                      CONTESTATION_AGAINST.VEHICLE && (
                      <FormContainer>
                        <FormGroup>
                          {vehicules.map((vehicule: any, index: number) => (
                            <FormControlLabel
                              key={index}
                              control={
                                <Checkbox
                                  data-testid="checkboxId"
                                  checked={IsVehicleChecked(
                                    vehicule.id,
                                    selectedVehicles,
                                  )}
                                  color="primary"
                                  onChange={handleVehicleChangeCheckBox(
                                    vehicule.id,
                                  )}
                                />
                              }
                              label={vehicule.registrationNumber}
                            />
                          ))}
                        </FormGroup>
                      </FormContainer>
                    )}
                    <FormContainer>
                      <FormControl className="formEl">
                        <TextField
                          label={translate(
                            {
                              ...messages.judgementOnMeritsContestationCommentary,
                            },
                            props,
                          )}
                          className="formEl"
                          onChange={handleFormChange(CONTESTATION.COMMENTARY)}
                          name={CONTESTATION.COMMENTARY}
                          value={get(formContestationValues, [
                            CONTESTATION.COMMENTARY,
                          ])}
                        />
                      </FormControl>
                    </FormContainer>
                    <FormContainer>
                      <FormControl className="formEl">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={IsDifficultyExecutionChecked}
                              color="primary"
                              onChange={handleDifficultyExecutionCheckBox}
                            />
                          }
                          label={translate(
                            messages.judgementOnMeritsContestationDifficultyExecution,
                            props,
                          )}
                        />
                      </FormControl>
                    </FormContainer>
                  </SahamDrawer>
                </div>
              ) : (
                <PrimaryButton
                  data-testid="validate"
                  background={BUTTON_COLORS.PRIMARY_BLUE}
                  border={BUTTON_COLORS.PRIMARY_BLUE}
                  titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                  title={translate(messages.validateButton, props)}
                  onClick={handleValidateJudgementOnMerits(true, false)}
                />
              )}
            </div>
          )}
      </div>
      {openDialogValidation &&
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) && (
          <ValidationDialog
            open={openDialogValidation}
            handleClose={() => setOpenDialogValidation(false)}
            handleValidate={handleValidateJudgementOnMerits(false, false)}
          />
        )}
      <RejectionDialog
        isRejectionDialogOpen={isRejectionDialogOpen}
        setIsRejectionDialogOpen={setIsRejectionDialogOpen}
        requestValidateJudgementOnMerits={requestValidateJudgementOnMerits}
        lawyer={getValueByCode(
          get(claim, 'assignment.assignedLawyer', ''),
          get(listings, 'intervenants', []),
        )}
        claimId={claimId}
        claimNumber={claimNumber}
        judiciaryProcessId={get(
          judgementOnMerits['judgementOnMerits'],
          'judiciaryProcessId',
        )}
        judgementId={get(judgementOnMerits['judgementOnMerits'], 'id')}
        jomId={get(judgementOnMerits, 'judgementOnMerits.jom.id', '')}
        isAppeal
        setJomStatus={setJomStatus}
        judgementDate={moment(
          get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
        ).format('DD/MM/YYYY')}
        isMultiple
        isFirst
        setIsButtonRedirect={props.setIsButtonRedirect}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      {openDialog && (
        <Dialog
          open={openDialog}
          handleClose={handleCloseDialog}
          handleValidate={handleValidateArchiveJudgement}
          title={translate(messages.archiveJudgementTitle, props)}
          confirmTitle={translate(messages.confirm, props)}
          cancelTitle={translate(messages.cancel, props)}
        >
          <div className="content">
            {translate(messages.archiveJudgementSubTitle, props)}
          </div>
          <TextField
            name="ArchiveReason"
            fullWidth
            value={archiveReason}
            onChange={handleChange}
            error={isEmpty(archiveReason)}
            helperText={
              isEmpty(archiveReason) &&
              translate(messages.archiveReasonFieldError, props)
            }
            multiline
          />
        </Dialog>
      )}
    </Container>
  );
};

export default injectIntl(JudgementOnMeritsManagerRecapAppeal);
